"use strict";

const STATION_ID = stationId;
const DEVICE_ID = deviceId;
const STATION_TYPE = stationType;
const STATION_NAME = $("#station-name").val() || "";
const UNIT_DISPLAY = $("#unit-display").val();
const AWLR_TYPE = $("#awlr-type").val();
const IS_AGWLR = STATION_TYPE == EnumStationType.AGWLR;
const IS_OW = STATION_TYPE == EnumStationType.ObservationWell;
const IS_TMAT = IS_AGWLR; // OW punya konfigurasi tabel sendiri
function getLastReadingDateFromDomOrApi() {
  const raw = ($("#last-date").val() || "").trim();
  const parsed = moment(raw, "YYYY-MM-DD", true);
  if (parsed.isValid()) {
    return parsed.format("YYYY-MM-DD");
  }

  const fromApi = getLastReadingDate(DEVICE_ID);
  if (fromApi) {
    $("#last-date").val(fromApi);
    return fromApi;
  }

  return moment().format("YYYY-MM-DD");
}

function toPickerDateString(dateInput) {
  const parsed = moment(dateInput, ["YYYY-MM-DD", "Y-M-D"], true);
  if (parsed.isValid()) {
    return parsed.format("YYYY-MM-DD");
  }
  return getLastReadingDateFromDomOrApi();
}

let LAST_READING_DATE = getLastReadingDateFromDomOrApi();
$("#periode").val(LAST_READING_DATE);
const UNIT_SENSOR =
  $("#unit-sensor").val() == null ? "" : $("#unit-sensor").val();
const IS_ONLY_MDPL = UNIT_SENSOR.includes("pl");
const WELL_DEPTH_UNIT = $("#well_depth_unit").val();
const TIME_ZONE = $("#time-zone").val();
const PEISCHAAL_ELEVATION =
  $("#peilschaal-elevation").val() == "" ? false : true;
let PEISCHAAL_ELEVATION_VALUE = 0;
const OrganizationCode = $("#organization-code").val();

/**
 * Kolom No. dan Jumlah Data pada tabel Per 5 Menit: semua tipe station, semua org.
 * Jendela hari hidrologi (D-1 07:00 → D 06:55) tetap hanya ARR + allowlist org
 * (OrganizationHelper.ArrMinuteHydroDayOrgCodes, default ORG014).
 * Tipe lain memakai hari kalender 00:00–23:55 (288 slot × 5 menit).
 */
const ARR_MINUTE_HYDRO_DAY_ENABLED =
  $("#arr-minute-hydro-day-enabled").val() === "1";

function isArrMinuteHydroDayEnabled(timeCategory) {
  return (
    ARR_MINUTE_HYDRO_DAY_ENABLED &&
    STATION_TYPE == EnumStationType.ARR &&
    timeCategory === "minute"
  );
}

/** Awal hari hidrologi relatif filterDate: (D-1) 07:00 (UTC wall-clock, sama seperti filter Mongo). */
function getArrHydroDayStart(filterDate) {
  return moment
    .utc(filterDate, "YYYY-MM-DD", true)
    .subtract(1, "day")
    .hour(7)
    .minute(0)
    .second(0)
    .millisecond(0);
}

/**
 * No. urut sesuai jumlah data (tanpa loncat).
 * Data diurut descending (terbaru di atas): No. 1 = data tertua (~07:00 D-1),
 * No. N = data terbaru (~06:55 D).
 */
function getArrHydroDaySequentialNumber(meta) {
  if (!meta || !meta.settings) {
    return "";
  }
  var api = new $.fn.dataTable.Api(meta.settings);
  var json = api.ajax.json();
  var total =
    json && typeof json.recordsTotal === "number"
      ? json.recordsTotal
      : api.rows({ page: "current" }).count();
  if (!total) {
    return "";
  }
  return total - meta.row;
}

/** Cache terakhir untuk popup gap ARR hydro day. */
var arrHydroDayGapContext = null;

var ARR_HYDRO_DAY_SLOT_COUNT = 288; // 24 jam × 12 slot/jam, tiap 5 menit

function readingAtToHydroSlotKey(readingAt) {
  var parsed = moment.parseZone(readingAt);
  if (!parsed.isValid()) {
    return null;
  }
  return moment
    .utc([
      parsed.year(),
      parsed.month(),
      parsed.date(),
      parsed.hour(),
      parsed.minute(),
      0,
    ])
    .format("YYYY-MM-DD HH:mm");
}

/** Awal jendela 288 slot: hari hidrologi untuk ARR allowlist, selain itu 00:00 hari filter. */
function getMinuteSlotStart(filterDate) {
  if (isArrMinuteHydroDayEnabled("minute")) {
    return getArrHydroDayStart(filterDate);
  }
  return moment.utc(filterDate, "YYYY-MM-DD", true).startOf("day");
}

/** Daftar slot 5 menit yang kosong di jendela filterDate. */
function getArrHydroDayMissingSlots(filterDate, rows) {
  var start = getMinuteSlotStart(filterDate);
  if (!start.isValid()) {
    return [];
  }

  var present = {};
  (rows || []).forEach(function (row) {
    var raw = row && (row.readingAt != null ? row.readingAt : row.ReadingAt);
    var key = readingAtToHydroSlotKey(raw);
    if (key) {
      present[key] = true;
    }
  });

  var missing = [];
  var i;
  for (i = 0; i < ARR_HYDRO_DAY_SLOT_COUNT; i++) {
    var slot = start.clone().add(i * 5, "minutes");
    var key = slot.format("YYYY-MM-DD HH:mm");
    if (!present[key]) {
      missing.push(slot);
    }
  }
  return missing;
}

function showArrHydroDayMissingPopup() {
  if (!arrHydroDayGapContext) {
    return;
  }

  var filterDate = arrHydroDayGapContext.filterDate;
  var rows = arrHydroDayGapContext.rows || [];
  var total = arrHydroDayGapContext.total || rows.length;
  var missing = getArrHydroDayMissingSlots(filterDate, rows);
  var start = getMinuteSlotStart(filterDate);
  var end = start.clone().add((ARR_HYDRO_DAY_SLOT_COUNT - 1) * 5, "minutes");
  var rangeLabel =
    start.locale("id").format("D MMMM YYYY HH:mm") +
    " s/d " +
    end.locale("id").format("D MMMM YYYY HH:mm");

  if (typeof Swal === "undefined") {
    window.alert(
      missing.length
        ? "Data hilang: " + missing.length + " slot\n" + rangeLabel
        : "Semua data lengkap (" + total + "/" + ARR_HYDRO_DAY_SLOT_COUNT + ")",
    );
    return;
  }

  var bodyHtml;
  if (!missing.length) {
    bodyHtml =
      '<p class="mb-1">Periode: <strong>' +
      rangeLabel +
      "</strong></p>" +
      '<p class="mb-0 text-success">Semua data lengkap (' +
      total +
      "/" +
      ARR_HYDRO_DAY_SLOT_COUNT +
      ").</p>";
  } else {
    var listItems = missing
      .map(function (slot) {
        return (
          "<li>" +
          slot.locale("id").format("D MMMM YYYY") +
          " &mdash; " +
          slot.format("HH:mm") +
          "</li>"
        );
      })
      .join("");
    bodyHtml =
      '<p class="mb-1">Periode: <strong>' +
      rangeLabel +
      "</strong></p>" +
      '<p class="mb-2">Jumlah Data = <strong>' +
      total +
      "</strong> / " +
      ARR_HYDRO_DAY_SLOT_COUNT +
      " &nbsp;|&nbsp; Tidak ada: <strong>" +
      missing.length +
      "</strong></p>" +
      '<div style="max-height:320px;overflow:auto;text-align:left;">' +
      '<ol class="mb-0 ps-3" style="font-size:13px;">' +
      listItems +
      "</ol></div>";
  }

  Swal.fire({
    title: "Data Per 5 Menit yang Tidak Ada",
    html: bodyHtml,
    width: 480,
    confirmButtonText: "Tutup",
    confirmButtonColor: "#3085d6",
  });
}

function updateTelemetryDatatableRowCount(text, options) {
  var $el = $("#telemetry-datatable-row-count");
  if (!$el.length) {
    return;
  }
  options = options || {};
  if (text) {
    $el.text(text).show();
    if (options.clickable) {
      $el
        .css({ cursor: "pointer", textDecoration: "underline" })
        .attr("title", "Klik untuk melihat data yang tidak ada")
        .attr("role", "button")
        .addClass("telemetry-datatable-row-count-clickable");
    } else {
      $el
        .css({ cursor: "", textDecoration: "" })
        .removeAttr("title")
        .removeAttr("role")
        .removeClass("telemetry-datatable-row-count-clickable");
    }
  } else {
    $el
      .text("")
      .hide()
      .css({ cursor: "", textDecoration: "" })
      .removeAttr("title")
      .removeAttr("role")
      .removeClass("telemetry-datatable-row-count-clickable");
    arrHydroDayGapContext = null;
  }
}

$(document).on("click", "#telemetry-datatable-row-count.telemetry-datatable-row-count-clickable", function (e) {
  e.preventDefault();
  showArrHydroDayMissingPopup();
});

function shiftColumnDefTargets(columnDef) {
  if (!Array.isArray(columnDef)) {
    return columnDef;
  }
  return columnDef.map(function (def) {
    if (!def || def.targets == null) {
      return def;
    }
    var next = $.extend({}, def);
    if (typeof next.targets === "number") {
      next.targets = next.targets + 1;
    } else if (Array.isArray(next.targets)) {
      next.targets = next.targets.map(function (target) {
        return typeof target === "number" ? target + 1 : target;
      });
    }
    return next;
  });
}

/** Sisipkan kolom No. di tabel Per 5 Menit. Header dua baris memakai rowspan. */
function prepareMinuteRowMeta(columns, columnDef, headerRow, timeCategory) {
  if (timeCategory !== "minute" || !columns || !columns.length || !headerRow) {
    return {
      columns: columns,
      columnDef: columnDef,
      headerRow: headerRow,
      applied: false,
    };
  }

  var nextColumns = columns.slice();
  nextColumns.unshift({
    data: null,
    name: "RowNumber",
    orderable: false,
    searchable: false,
    defaultContent: "",
    className: "text-center",
    render: function (_data, _type, _row, meta) {
      return getArrHydroDaySequentialNumber(meta);
    },
  });

  var rowCount = (String(headerRow).match(/<tr\b/gi) || []).length;
  var th =
    rowCount > 1
      ? '<th scope="col" rowspan="2" class="text-center">No.</th>'
      : '<th scope="col" class="text-center">No.</th>';
  var nextHeader = String(headerRow).replace(/<tr\b[^>]*>/i, function (match) {
    return match + th;
  });

  return {
    columns: nextColumns,
    columnDef: shiftColumnDefTargets(columnDef),
    headerRow: nextHeader,
    applied: true,
  };
}

function paintMinuteRowCount(api, filterDate) {
  var json = api.ajax.json();
  var rows =
    json && Array.isArray(json.data)
      ? json.data
      : api.rows().data().toArray();
  var total =
    json && typeof json.recordsTotal === "number"
      ? json.recordsTotal
      : rows.length;
  arrHydroDayGapContext = {
    filterDate: filterDate,
    rows: rows,
    total: total,
  };
  updateTelemetryDatatableRowCount(
    "Jumlah Data = " + total + " / " + ARR_HYDRO_DAY_SLOT_COUNT,
    { clickable: true },
  );
}

function withMinuteRowCount(dtOptions, timeCategory, filterDate, applied) {
  if (!applied || timeCategory !== "minute") {
    return dtOptions;
  }
  var previous = dtOptions.drawCallback;
  dtOptions.drawCallback = function (settings) {
    if (typeof previous === "function") {
      previous.call(this, settings);
    }
    paintMinuteRowCount(this.api(), filterDate);
  };
  return dtOptions;
}

if (PEISCHAAL_ELEVATION) {
  PEISCHAAL_ELEVATION_VALUE = parseFloat($("#peilschaal-elevation").val(), 2);
}

function rowHasWaterLevelElevation(row) {
  return (
    row && row.waterLevelElevation != null && row.waterLevelElevation !== ""
  );
}

function dataHasWaterLevelElevation(rows) {
  if (!Array.isArray(rows)) {
    return false;
  }
  return rows.some(rowHasWaterLevelElevation);
}

function appendAgwlrElevMatColumn(columns) {
  var elevCol = {
    data: "waterLevelElevation",
    name: "WaterLevelElevation",
    visible: false,
    render: function (data) {
      if (data == null || data === "") {
        return "-";
      }
      return "<strong>" + formatNumber(data) + "</strong>";
    },
  };
  var insertAt = -1;
  var i;
  for (i = 0; i < columns.length; i++) {
    if (columns[i].data === "waterLevel") {
      insertAt = i + 1;
      break;
    }
  }
  if (insertAt < 0) {
    return -1;
  }
  columns.splice(insertAt, 0, elevCol);
  return insertAt;
}

function injectAgwlrElevMatHeader(headerRowHtml) {
  var elevHeader =
    '<th scope="col" rowspan="2">Elev. MAT <small class="text-muted">(mdpl)</small></th>';
  var re = /(<th[^>]*>[\s\S]*?\bMAT\b(?![\s\S]*?Sensor)[\s\S]*?<\/th>)/i;
  if (!re.test(headerRowHtml)) {
    return headerRowHtml;
  }
  return headerRowHtml.replace(re, "$1\n                  " + elevHeader);
}

function mergeAgwlrElevColumnDef(columnDef, colIndex) {
  if (colIndex < 0) {
    return columnDef;
  }
  var targets = [];
  if (columnDef.length && Array.isArray(columnDef[0].targets)) {
    targets = columnDef[0].targets.slice();
  }
  if (targets.indexOf(colIndex) === -1) {
    targets.push(colIndex);
  }
  return [{ className: "dt-center", targets: targets }];
}

const POWER_SOURCE = $("#power-source").val();
const USE_BATTERY_COLUMN = POWER_SOURCE == "B";
let sensorNames = [];
$("#arr-telemetry-info").fadeOut(250);
$("#awlr-telemetry-info").fadeOut(250);
const awsSensors = {
  humidity: {
    unit: "%",
    color: "#00008B",
    sensorName: "Kelembaban",
  },
  pressure: {
    unit: "MB",
    color: "#2E8B57",
    sensorName: "Tekanan",
  },
  rainfall: {
    unit: "mm",
    color: "#FFA500",
    sensorName: "Curah Hujan",
  },
  solarRadiation: {
    unit: "W/s<sup>2</sup>",
    color: "#8B0000",
    sensorName: "Radiasi Matahari",
  },
  temperature: {
    unit: "&degC",
    color: "#3498db",
    sensorName: "Suhu",
  },
  windDirection: {
    unit: "&deg",
    color: "#696969",
    sensorName: "Arah Angin",
  },
  windSpeed: {
    unit: "Km/j",
    color: "#A9A9A9",
    sensorName: "Kecepatan Angin",
  },
  evaporation: {
    unit: "mm",
    color: "#4682B4",
    sensorName: "Tinggi Penguapan",
  },
  uv: {
    unit: "nm",
    color: "#AA5486",
    sensorName: "Ultraviolet",
  },
};

let selected_time = "minute";
let filter_date;
let suppressPickerReload = false;
let countClickTabTelemetri = 0;
let momentjs = moment();
momentjs.locale("id");
switch (TIME_ZONE) {
  case "WITA":
    momentjs.tz("Asia/Makassar");
    break;
  case "WIT":
    momentjs.tz("Asia/Jayapura");
    break;
  default:
    momentjs.tz("Asia/Jakarta");
    break;
}

if (
  STATION_TYPE == EnumStationType.AWS ??
  STATION_TYPE == EnumStationType.WaterQuality
) {
  sensorNames = $("#sensor-name").val().split(",");
  console.log(sensorNames);
}

function generateStyleWaterLevel(td, cellData, rowData, row, col) {
  if (IS_ONLY_MDPL) {
    return;
  }

  $(td).removeClass("bg-normal");
  $(td).removeClass("bg-siaga3");
  $(td).removeClass("bg-siaga2");
  $(td).removeClass("bg-siaga1");
  $(td).removeClass("bg-nostatus");

  if (rowData.unitSensor != "cmdpl" && rowData.unitSensor != "mdpl") {
    switch (rowData.warningStatus) {
      case 0:
        $(td).addClass("bg-normal");
        break;

      case 3:
        $(td).addClass("bg-siaga3");
        break;

      case 2:
        $(td).addClass("bg-siaga2");
        break;

      case 1:
        $(td).addClass("bg-siaga1");
        break;
      default:
        $(td).addClass("bg-nostatus");
        break;
    }
  }
}

/** Tanggal acuan untuk init picker: menit=last reading, jam=bulan last reading, harian=tahun last reading. */
function defaultSeedDayIsoForTimeCategory(timeCategory) {
  const lastReading = moment(LAST_READING_DATE, "YYYY-MM-DD");
  if (timeCategory === "minute") {
    return lastReading.format("YYYY-MM-DD");
  }
  if (timeCategory === "hour") {
    return lastReading.clone().startOf("month").format("YYYY-MM-DD");
  }
  if (timeCategory === "day") {
    return lastReading.clone().startOf("year").format("YYYY-MM-DD");
  }
  return lastReading.format("YYYY-MM-DD");
}

function resolveTableFilterPeriod(timeCategory) {
  const tc = timeCategory || selected_time;
  const lastReading = moment(LAST_READING_DATE, "YYYY-MM-DD");
  let selectedPeriode = $("#periode").val();
  if (!selectedPeriode) {
    if (tc === "day") {
      selectedPeriode = lastReading.format("YYYY");
    } else if (tc === "hour") {
      selectedPeriode = lastReading.format("YYYY-MM");
    } else {
      selectedPeriode = lastReading.format("YYYY-MM-DD");
    }
  }

  if (tc === "hour") {
    let parsedHour = moment(
      selectedPeriode,
      ["YYYY-MM", "YYYY-MM-DD", "MMMM YYYY", "MMM YYYY"],
      "id",
      true,
    );

    if (!parsedHour.isValid()) {
      parsedHour = moment(
        selectedPeriode,
        ["YYYY-MM", "YYYY-MM-DD", "MMMM YYYY", "MMM YYYY"],
        true,
      );
    }

    if (parsedHour.isValid()) {
      selectedPeriode = parsedHour.format("YYYY-MM");
    } else if (moment(selectedPeriode, "YYYY", true).isValid()) {
      selectedPeriode = lastReading
        .clone()
        .year(Number(selectedPeriode))
        .format("YYYY-MM");
    } else {
      selectedPeriode = lastReading.format("YYYY-MM");
    }
  }

  return selectedPeriode;
}

/** Format filterDate untuk request DataTable sesuai mode waktu. */
function resolveFilterDateForRequest(timeCategory, seedDayIso) {
  const seed = moment(seedDayIso, "YYYY-MM-DD");
  const lastReading = moment(LAST_READING_DATE, "YYYY-MM-DD");
  if (timeCategory === "day") {
    return seed.format("YYYY");
  }
  if (timeCategory === "hour") {
    if (seed.isSame(lastReading, "year") && seed.isSame(lastReading, "month")) {
      return lastReading.format("YYYY-MM-DD");
    }
    return seed.format("YYYY-MM");
  }
  return seed.format("YYYY-MM-DD");
}

function reloadTelemetryDataTable() {
  selected_time = $("#waktu").val();
  if (isAvwrTelemetryEnabled()) {
    const avwrTelemetry = getAvwrTelemetryModule();
    if (avwrTelemetry) {
      selected_time = avwrTelemetry.enforceHourMode(selected_time);
    }
  }
  generateDataTable(
    STATION_TYPE,
    "table-telemetri",
    selected_time,
    resolveTableFilterPeriod(selected_time),
  );
}

function isAvwrTelemetryEnabled() {
  return STATION_TYPE == EnumStationType.VibratingWire;
}

function getAvwrTelemetryModule() {
  if (typeof window.AvwrTelemetry === "undefined") {
    return null;
  }
  return window.AvwrTelemetry;
}

$(document).ready(function () {
  LAST_READING_DATE = getLastReadingDateFromDomOrApi();
  filter_date = LAST_READING_DATE;
  selected_time = $("#waktu").val() == undefined ? "minute" : $("#waktu").val();

  if (isAvwrTelemetryEnabled()) {
    const avwrTelemetry = getAvwrTelemetryModule();
    if (avwrTelemetry) {
      selected_time = avwrTelemetry.enforceHourMode(selected_time);
      avwrTelemetry.init({
        lastReadingDate: LAST_READING_DATE,
      });
    }
  }
  //initialize ddatePicker ID manual config
  $.fn.datepicker.dates["id"] = {
    days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"],
    daysShort: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
    daysMin: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
    months: [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ],
    monthsShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Okt",
      "Nov",
      "Des",
    ],
    today: "Hari Ini",
    clear: "Clear",
    format: "yyyy-mm-dd",
    titleFormat: "MM yyyy" /* Leverages the same syntax as ‘format’ */,
    weekStart: 0,
  };
  // Handle change event for #waktu

  $("#waktu").on("change", function () {
    selected_time = $(this).val();
    if (isAvwrTelemetryEnabled()) {
      const avwrTelemetry = getAvwrTelemetryModule();
      if (avwrTelemetry) {
        selected_time = avwrTelemetry.enforceHourMode(selected_time);
      }
    }
    const seedDayIso = defaultSeedDayIsoForTimeCategory(selected_time);
    filter_date = seedDayIso;
    loadFlatPickr("periode", selected_time, seedDayIso);

    if (STATION_TYPE == EnumStationType.ARR) {
      if (selected_time == "minute") {
        $(".arr-parameter-parent").fadeOut(100);
        $("#data-telemetry-info").text("");
      } else if (selected_time == "hour") {
        $(".arr-parameter-parent").fadeIn(100);
        $("#arr-day-parameter").fadeOut(0);
        $("#arr-hour-parameter").fadeIn(100);
        let t = `<i class="mdi mdi-information"></i>
                                        <span id="arr-desc"> Data akumulasi per jam dihitung 1 jam sebelumnya   </span>`;
        $("#data-telemetry-info").html(t);
      } else {
        $(".arr-parameter-parent").fadeIn(100);
        $("#arr-hour-parameter").fadeOut(0);
        $("#arr-day-parameter").fadeIn(100);
        let t = `<i class="mdi mdi-information"></i>
                                        <span id="arr-desc"> Data akumulasi per hari dihitung Pkl 07:00 s.d 06:59 (H-1)   </span>`;
        $("#data-telemetry-info").html(t);
      }
    }

    generateDataTable(
      STATION_TYPE,
      "table-telemetri",
      selected_time,
      resolveFilterDateForRequest(selected_time, seedDayIso),
    );
    if (isAvwrTelemetryEnabled()) {
      const avwrTelemetry = getAvwrTelemetryModule();
      if (avwrTelemetry) avwrTelemetry.loadChart();
    }

    showHideAwlrInfo(STATION_TYPE, selected_time);

    $('[data-bs-toggle="tooltip"]').tooltip();
  });

  // Handle change event for #periode (bootstrap datepicker legacy)
  $("#periode").on("change", function () {
    reloadTelemetryDataTable();
  });

  function showHideAwlrInfo(type, selected_time) {
    if (type != EnumStationType.AWLR_ARR) return;
    if (type == EnumStationType.AWLR_ARR && selected_time == "minute") {
      $("#awlr-telemetry-info").show();
    } else {
      $("#awlr-telemetry-info").hide();
    }
  }

  $("#tab-telemetri").trigger("click");
});

$("#tab-info").on("click", function () {
  $("#arr-telemetry-info").fadeOut(150);
  $("#awlr-telemetry-info").fadeOut(150);
});

$("#tab-telemetri").on("click", function () {
  if (STATION_TYPE == EnumStationType.ARR && $("#waktu").val() != "minute") {
    $("#arr-telemetry-info").fadeIn(250);
  }
  if (
    (STATION_TYPE == EnumStationType.AWLR ||
      STATION_TYPE == EnumStationType.AGWLR) &&
    $("#waktu").val() != "day"
  ) {
    $("#awlr-telemetry-info").fadeIn(250);
  }
  if (STATION_TYPE == EnumStationType.AWS && $("#waktu").val() != "minute") {
    $("#arr-telemetry-info").fadeIn(250);
  }

  if (
    STATION_TYPE == EnumStationType.AWLR_ARR &&
    $("#waktu").val() == "minute"
  ) {
    $("#awlr-telemetry-info").fadeIn(250);
    $("#arr-telemetry-info").fadeOut(250);
  } else if (
    STATION_TYPE == EnumStationType.AWLR_ARR &&
    $("#waktu").val() == "day"
  ) {
    $("#awlr-telemetry-info").fadeOut(150);
    $("#arr-telemetry-info").fadeIn(250);
  } else {
    $("#awlr-telemetry-info").fadeIn(250);
    $("#arr-telemetry-info").fadeIn(250);
  }

  if (countClickTabTelemetri > 0) {
    return;
  }

  countClickTabTelemetri++;

  momentjs = moment(new Date(LAST_READING_DATE));

  selected_time = $("#waktu").val() == undefined ? "minute" : $("#waktu").val();
  if (isAvwrTelemetryEnabled()) {
    const avwrTelemetry = getAvwrTelemetryModule();
    if (avwrTelemetry) {
      selected_time = avwrTelemetry.enforceHourMode(selected_time);
    }
  }

  const pickerSeed = defaultSeedDayIsoForTimeCategory(selected_time);
  filter_date = pickerSeed;
  loadFlatPickr("periode", selected_time, pickerSeed);

  generateDataTable(
    STATION_TYPE,
    "table-telemetri",
    selected_time,
    resolveFilterDateForRequest(selected_time, pickerSeed),
  );
  if (isAvwrTelemetryEnabled()) {
    const avwrTelemetry = getAvwrTelemetryModule();
    if (avwrTelemetry) avwrTelemetry.loadChart();
  }
});
function loadFlatPickr(id, waktu, date) {
  const el = document.getElementById(id);
  if (el && el._flatpickr) {
    el._flatpickr.destroy();
  }

  $(`#${id}`).datepicker("destroy");
  const pickerDate = toPickerDateString(date);
  filter_date = pickerDate;

  const onPickerChange = function (_selectedDates, dateStr) {
    if (suppressPickerReload) {
      return;
    }
    if (dateStr) {
      const parsed = moment(dateStr, ["Y-m-d", "Y-m", "YYYY"], true);
      if (parsed.isValid()) {
        filter_date = parsed.format("YYYY-MM-DD");
      }
    }
    reloadTelemetryDataTable();
  };

  suppressPickerReload = true;
  switch (waktu) {
    case "hour":
      flatpickr(`#${id}`, {
        altInput: true,
        locale: "id",
        defaultDate: pickerDate,
        maxDate: new Date(),
        onChange: onPickerChange,
        plugins: [
          new monthSelectPlugin({
            altInput: true,
            shorthand: true,
            dateFormat: "Y-m",
            altFormat: "F Y",
            theme: "light",
          }),
        ],
      });
      break;
    case "day":
      const seedYear = moment(pickerDate, "YYYY-MM-DD").format("YYYY");
      $(`#${id}`)
        .datepicker({
          format: "yyyy",
          viewMode: "years",
          minViewMode: "years",
          autoclose: true,
          todayHighlight: true,
          endDate: new Date(),
          orientation: "bottom",
        })
        .off("changeDate.telemetry")
        .on("changeDate.telemetry", function () {
          if (suppressPickerReload) {
            return;
          }
          reloadTelemetryDataTable();
        });
      $(`#${id}`).datepicker("update", seedYear);
      $(`#${id}`).val(seedYear);
      break;
    default:
      flatpickr(`#${id}`, {
        locale: "id",
        defaultDate: pickerDate,
        altInput: true,
        altFormat: "j F Y",
        dateFormat: "Y-m-d",
        maxDate: new Date(),
        onChange: onPickerChange,
      });
      break;
  }
  suppressPickerReload = false;
}
function capitalizeFirstLetter(str) {
  // Check if the string is not empty
  if (str.length === 0) {
    return "";
  }

  // Capitalize the first character and concatenate it with the rest of the string
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function checkIsCurrentTimeBefore7AM() {
  // Get the current date and time
  var currentDate = new Date();

  // Get the current hour and minute
  var currentHour = currentDate.getHours();
  var currentMinute = currentDate.getMinutes();

  // Check if the current time is between 12:00 AM and 6:59 AM
  if (currentHour >= 0 && currentHour < 7) {
    return true;
  } else {
    return false;
  }
}

function generateDataTable(typePos, idTable, timeCategory, filterDate) {
  let COLUMNS = [];
  let COLUMNDEF = [];

  moment.locale("id");
  updateTelemetryDatatableRowCount("");
  if ($.fn.DataTable.isDataTable("#" + idTable)) {
    $("#" + idTable)
      .DataTable()
      .clear()
      .destroy();
  }

  let HEADER_ROW;

  if (typePos == EnumStationType.ARR) {
    switch (timeCategory) {
      case "minute":
        $("#arr-telemetry-info").fadeOut(250);
        COLUMNS = [
          {
            data: "readingAt",
            name: "ReadingAt",
            render: function (data, type, row) {
              return moment.parseZone(data).format("D MMMM YYYY");
            },
          },
          {
            data: "readingAt",
            name: "ReadingAt",
            render: function (data, type, row) {
              return moment.parseZone(data).format("HH:mm");
            },
          },
          {
            data: "rainfall",
            name: "Rainfall",
            render: function (data) {
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "batteryVoltage",
            name: "BatteryVoltage",
            render: function (data) {
              return formatNumber(data);
            },
          },
          {
            data: "batteryCapacity",
            name: "BatteryCapacity",
            render: function (data) {
              return formatNumber(data);
            },
          },
        ];
        COLUMNDEF = [
          {
            targets: [2],
            render: function (data, type, row) {
              return `<strong>${data}</strong>`;
            },
          },
        ];

        HEADER_ROW = `
          <tr>
            <th scope="col" rowspan="2">Tanggal</th>
            <th scope="col" rowspan="2">
              Jam <small class="text-muted">(${TIME_ZONE})</small>
            </th>
            <th scope="col" rowspan="2">
              Curah Hujan <small class="text-muted">(mm)</small>
            </th>

            <!-- BATERAI -->
            <th scope="col" colspan="2">Baterai</th>
          </tr>
          <tr>
            <th scope="col">Tegangan <small class="text-muted">(V)</small></th>
            <th scope="col">Kapasitas <small class="text-muted">(%)</small></th>
          </tr>
        `;

        if (!USE_BATTERY_COLUMN) {
          // Hilangkan kolom battery dari DataTables
          COLUMNS = COLUMNS.filter(
            (item) =>
              item.name !== "BatteryVoltage" && item.name !== "BatteryCapacity",
          );

          HEADER_ROW = `
            <tr>
              <th scope="col">Tanggal</th>
              <th scope="col">
                Jam <small class="text-muted">(${TIME_ZONE})</small>
              </th>
              <th scope="col">
                CH <small class="text-muted">(mm)</small>
              </th>
            </tr>
          `;
        }

        break;
      case "hour":
        $("#arr-telemetry-info").fadeIn(250);
        HEADER_ROW = `<tr>
                        <th scope="col">Tanggal</th>
                        <th scope="col">Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                        <th scope="col">Curah Hujan <small class="text-muted">(mm)</small></th>
                        <th scope="col">Intensitas</th>
                      </tr>`;

        COLUMNS = [
          {
            data: "readingHour",
            name: "ReadingHour",
            render: function (data, type, row) {
              return moment.parseZone(data).format("D MMMM YYYY");
            },
          },
          {
            data: "readingHour",
            name: "ReadingHour",
            render: function (data, type, row) {
              return moment.parseZone(data).format("HH:mm");
            },
          },
          {
            data: "rainfall",
            name: "Rainfall",
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData > 0 && cellData < 5.1) {
                $(td).addClass("bg-hujan-ringan");
              } else if (cellData > 5 && cellData < 10.1) {
                $(td).addClass("bg-hujan-sedang");
              } else if (cellData > 10 && cellData < 20.1) {
                $(td).addClass("bg-hujan-lebat");
              } else if (cellData > 20) {
                $(td).addClass("bg-hujan-sangat-lebat");
              } else {
                $(td).addClass("bg-berawan");
              }
            },
            render: function (data) {
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "intensity",
            name: "Intensity",
            render: function (data) {
              return `
                      <div class="d-flex justify-content-center align-items-center">
                          ${getIntensityIcon(data)}
                      </div>
                  `;
            },
          },
        ];
        COLUMNDEF = [
          {
            targets: [2, 3],
            render: function (data, type, row) {
              return `<strong>${data}</strong>`;
            },
          },
        ];

        break;
      case "day":
        $("#arr-telemetry-info").fadeIn(250);
        HEADER_ROW = `<tr>
                        <th scope="col">Tanggal</th>
                        <th scope="col">Curah Hujan <small class="text-muted">(mm)</small></th>
                        <th scope="col">Intensitas</th>
                      </tr>`;
        COLUMNS = [
          {
            data: "readingDate",
            name: "ReadingDate",
            render: function (data, type, row) {
              return moment.parseZone(data).format("D MMMM YYYY");
            },
          },
          {
            data: "rainfall",
            name: "Rainfall",
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData > 5 && cellData < 20.1) {
                $(td).addClass("bg-hujan-ringan");
              } else if (cellData > 20 && cellData < 50.1) {
                $(td).addClass("bg-hujan-sedang");
              } else if (cellData > 50 && cellData < 100.1) {
                $(td).addClass("bg-hujan-lebat");
              } else if (cellData > 100) {
                $(td).addClass("bg-hujan-sangat-lebat");
              } else {
                $(td).addClass("bg-berawan");
              }
            },
            render: function (data) {
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "intensity",
            name: "Intensity",
            render: function (data) {
              return `
                      <div class="d-flex justify-content-center align-items-center">
                          ${getIntensityIcon(data)}
                      </div>
                  `;
            },
          },
        ];
        COLUMNDEF = [
          {
            targets: [1, 2],
            render: function (data, type, row) {
              return `<strong>${data}</strong>`;
            },
          },
        ];
        break;
      default:
        break;
    }

    var minuteMeta = prepareMinuteRowMeta(
      COLUMNS,
      COLUMNDEF,
      HEADER_ROW,
      timeCategory,
    );
    COLUMNS = minuteMeta.columns;
    COLUMNDEF = minuteMeta.columnDef;
    HEADER_ROW = minuteMeta.headerRow;

    $(`#${idTable} thead`).html(HEADER_ROW);
    $(`#${idTable}`).DataTable(withMinuteRowCount({
      dom: "rti",
      paging: false,
      ordering: false,
      processing: true,
      serverSide: true,
      ajax: {
        url: STATION_URL,
        type: "POST",
        data: {
          stationId: STATION_ID,
          deviceId: DEVICE_ID,
          filterDate: filterDate,
          selectedTime: timeCategory,
          stationType: STATION_TYPE,
        },
      },
      columnDefs: COLUMNDEF,
      columns: COLUMNS,
      language: {
        emptyTable: function () {
          if (isArrMinuteHydroDayEnabled(timeCategory)) {
            var hydroStart = getArrHydroDayStart(filterDate);
            return (
              "Data yang tersedia dimulai pada tanggal " +
              hydroStart.format("D MMMM YYYY") +
              " pukul 07:00"
            );
          }
          if (
            STATION_TYPE === "ARR" &&
            filterDate === moment().format("YYYY-MM-DD") &&
            moment().format("HH") < "07"
          ) {
            return `Data yang tersedia dimulai pada tanggal ${moment(
              filterDate,
            ).format("D MMMM YYYY")} pukul 07:00 Pagi`;
          } else {
            return "No data available";
          }
        },
      },
    }, timeCategory, filterDate, minuteMeta.applied));

    // const x = moment(new Date(), "YYYY-MM-DD").toDate();
    // $(`#periode`).datepicker("setDate", x);
  }

  if (typePos == EnumStationType.ObservationWell) {
    const owUnit = UNIT_DISPLAY || "m";
    const renderOwValue = function (data) {
      if (data == null || data === "") {
        return "-";
      }
      return formatNumber(data);
    };

    switch (timeCategory) {
      case "day":
        COLUMNS = [
          {
            data: "readingDate",
            name: "readingDate",
            render: function (data) {
              return moment.parseZone(data).format("D MMMM YYYY");
            },
          },
          {
            data: "waterLevel",
            name: "WaterLevel",
            render: renderOwValue,
          },
          {
            data: "waterLevelElevation",
            name: "WaterLevelElevation",
            render: renderOwValue,
          },
        ];
        COLUMNDEF = [{ className: "dt-center", targets: [1, 2] }];
        HEADER_ROW = `<tr>
                        <th scope="col">Tanggal</th>
                        <th scope="col">Muka Air Terhadap Top Pipa <small class="text-muted">(${owUnit})</small></th>
                        <th scope="col">Elevasi Muka Air <small class="text-muted">(mdpl)</small></th>
                      </tr>`;
        break;
      case "hour":
        COLUMNS = [
          {
            data: "readingHour",
            name: "ReadingHour",
            render: function (data) {
              return moment.parseZone(data).format("D MMMM YYYY");
            },
          },
          {
            data: "readingHour",
            name: "ReadingHour",
            render: function (data) {
              return moment.parseZone(data).format("HH:mm");
            },
          },
          {
            data: "waterLevel",
            name: "WaterLevel",
            render: renderOwValue,
          },
          {
            data: "waterLevelElevation",
            name: "WaterLevelElevation",
            render: renderOwValue,
          },
        ];
        COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3] }];
        HEADER_ROW = `<tr>
                        <th scope="col">Tanggal</th>
                        <th scope="col">Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                        <th scope="col">Muka Air Terhadap Top Pipa <small class="text-muted">(${owUnit})</small></th>
                        <th scope="col">Elevasi Muka Air <small class="text-muted">(mdpl)</small></th>
                      </tr>`;
        break;
      default:
        COLUMNS = [
          {
            data: "readingAt",
            name: "ReadingAt",
            render: function (data) {
              return moment.parseZone(data).format("D MMMM YYYY");
            },
          },
          {
            data: "readingAt",
            name: "ReadingAt",
            render: function (data) {
              return moment.parseZone(data).format("HH:mm");
            },
          },
          {
            data: "waterLevel",
            name: "WaterLevel",
            render: renderOwValue,
          },
          {
            data: "waterLevelElevation",
            name: "WaterLevelElevation",
            render: renderOwValue,
          },
        ];
        COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3] }];
        HEADER_ROW = `<tr>
                        <th scope="col">Tanggal</th>
                        <th scope="col">Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                        <th scope="col">Muka Air Terhadap Top Pipa <small class="text-muted">(${owUnit})</small></th>
                        <th scope="col">Elevasi Muka Air <small class="text-muted">(mdpl)</small></th>
                      </tr>`;
        break;
    }

    var minuteMeta = prepareMinuteRowMeta(
      COLUMNS,
      COLUMNDEF,
      HEADER_ROW,
      timeCategory,
    );
    COLUMNS = minuteMeta.columns;
    COLUMNDEF = minuteMeta.columnDef;
    HEADER_ROW = minuteMeta.headerRow;
    if (
      minuteMeta.applied &&
      typeof agwlrElevColIndex === "number" &&
      agwlrElevColIndex >= 0
    ) {
      agwlrElevColIndex += 1;
    }

    $(`#${idTable} thead`).html(HEADER_ROW);
    $(`#${idTable}`).DataTable(withMinuteRowCount({
      dom: "rti",
      paging: false,
      ordering: false,
      processing: true,
      serverSide: true,
      ajax: {
        url: STATION_URL,
        type: "POST",
        data: {
          stationId: STATION_ID,
          deviceId: DEVICE_ID,
          filterDate: filterDate,
          selectedTime: timeCategory,
          stationType: STATION_TYPE,
        },
      },
      columnDefs: COLUMNDEF,
      columns: COLUMNS,
    }, timeCategory, filterDate, minuteMeta.applied));
  } else if (
    typePos == EnumStationType.AWLR ||
    typePos == EnumStationType.AGWLR
  ) {
    switch (timeCategory) {
      case "day":
        $("#awlr-telemetry-info").fadeOut(250);
        COLUMNS = [
          {
            data: "readingDate",
            name: "readingDate",
            render: function (data, type, row) {
              return moment.parseZone(data).format("D MMMM YYYY");
            },
          },
          {
            data: "waterLevelAvg",
            name: "WaterLevelAvg",
            render: function (data) {
              return formatNumber(data);
            },
          },
          {
            data: "waterLevelMin",
            name: "WaterLevelMin",
            render: function (data) {
              return formatNumber(data);
            },
          },
          {
            data: "waterLevelMax",
            name: "WaterLevelMax",
            render: function (data) {
              return formatNumber(data);
            },
          },
          {
            data: "debitAvg",
            name: "DebitAvg",
            render: function (data) {
              return formatNumber(data);
            },
          },
        ];

        COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4] }];

        if (IS_ONLY_MDPL) {
          HEADER_ROW = `<tr>
                        <th scope="col">Tanggal</th>
                        <th scope="col">Elevasi Rerata <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                        <th scope="col">Elevasi Minimum <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                        <th scope="col">Elevasi Maksimum <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                        <th scope="col">Debit Rerata <small class="text-muted">(m3/s)</small></th>
                      </tr>`;
        } else {
          HEADER_ROW = `<tr>
                        <th scope="col">Tanggal</th>
                        <th scope="col">TMA Rerata <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                        <th scope="col">TMA Minimum <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                        <th scope="col">TMA Maksimum <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                        <th scope="col">Debit Rerata <small class="text-muted">(m3/s)</small></th>
                      </tr>`;
        }

        if (IS_TMAT) {
          COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3] }];
          if (OrganizationCode == "ORG084") {
            COLUMNS = [
              {
                data: "readingDate",
                name: "readingDate",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("D MMMM YYYY");
                },
              },
              {
                data: "waterLevelAvg",
                name: "WaterLevelAvg",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "waterLevelMin",
                name: "WaterLevelMin",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "waterLevelMax",
                name: "WaterLevelMax",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "ph",
                name: "ph",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "temperature",
                name: "temperature",
                render: function (data) {
                  return formatNumber(data);
                },
              },
            ];
            HEADER_ROW = `<tr>
                        <th scope="col">Tanggal</th>
                        <th scope="col">MAT Rerata <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                        <th scope="col">MAT Minimum <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                        <th scope="col">MAT Maksimum <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                          <th scope="col">pH <small class="text-muted"></small></th>
                            <th scope="col">Suhu <small class="text-muted">(°C)</small></th>
                      </tr>`;
          } else {
            COLUMNS = [
              {
                data: "readingDate",
                name: "readingDate",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("D MMMM YYYY");
                },
              },
              {
                data: "waterLevelAvg",
                name: "WaterLevelAvg",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "waterLevelMin",
                name: "WaterLevelMin",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "waterLevelMax",
                name: "WaterLevelMax",
                render: function (data) {
                  return formatNumber(data);
                },
              },
            ];
            HEADER_ROW = `<tr>
                        <th scope="col">Tanggal</th>
                        <th scope="col">MAT Rerata <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                        <th scope="col">MAT Minimum <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                        <th scope="col">MAT Maksimum <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                      </tr>`;
          }
        }

        break;
      case "hour":
        $("#awlr-telemetry-info").fadeIn(250);

        if (OrganizationCode == "ORG006") {
          if (PEISCHAAL_ELEVATION) {
            COLUMNS = [
              {
                data: "readingHour",
                name: "ReadingHour",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("D MMMM YYYY");
                },
              },
              {
                data: "readingHour",
                name: "ReadingHour",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("HH:mm");
                },
              },
              {
                data: "waterLevel",
                name: "WaterLevel",
                createdCell: function (td, cellData, rowData, row, col) {
                  $(td).removeClass("bg-normal");
                  $(td).removeClass("bg-siaga3");
                  $(td).removeClass("bg-siaga2");
                  $(td).removeClass("bg-siaga1");
                  $(td).removeClass("bg-nostatus");

                  if (
                    rowData.unitSensor != "cmdpl" &&
                    rowData.unitSensor != "mdpl"
                  ) {
                    switch (rowData.warningStatus) {
                      case 0:
                        $(td).addClass("bg-normal");
                        break;

                      case 3:
                        $(td).addClass("bg-siaga3");
                        break;

                      case 2:
                        $(td).addClass("bg-siaga2");
                        break;

                      case 1:
                        $(td).addClass("bg-siaga1");
                        break;
                      default:
                        $(td).addClass("bg-nostatus");
                        break;
                    }
                  }
                },
                render: function (data) {
                  return `<strong>${formatNumber(data)}</strong>`;
                },
              },

              {
                data: "waterLevelElevation",
                name: "WaterLevelElevation",
                createdCell: function (td, cellData, rowData, row, col) {
                  // if (!IS_ONLY_MDPL) {
                  //   return;
                  // }

                  $(td).removeClass("bg-normal");
                  $(td).removeClass("bg-siaga3");
                  $(td).removeClass("bg-siaga2");
                  $(td).removeClass("bg-siaga1");
                  $(td).removeClass("bg-nostatus");

                  if (
                    rowData.unitSensor != "cmdpl" &&
                    rowData.unitSensor != "mdpl"
                  ) {
                    // switch (rowData.warningStatus) {
                    //   case "Normal":
                    //     $(td).addClass("bg-normal");
                    //     break;
                    //   case "Siaga 3":
                    //     $(td).addClass("bg-siaga3");
                    //     break;
                    //   case "Siaga 2":
                    //     $(td).addClass("bg-siaga2");
                    //     break;
                    //   case "Siaga 1":
                    //     $(td).addClass("bg-siaga1");
                    //     break;
                    //   default:
                    //     $(td).addClass("bg-nostatus");
                    //     break;
                    // }
                  }
                },
                render: function (data) {
                  if (data == null) {
                    return "";
                  }
                  return `<strong>${formatNumber(data)}</strong>`;
                },
              },
              {
                data: "debit",
                name: "Debit",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "batteryVoltage",
                name: "BatteryVoltage",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "batteryCapacity",
                name: "BatteryCapacity",
                render: function (data) {
                  return data;
                },
              },
            ];
            COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4] }];
            HEADER_ROW = `
              <tr>
                <th scope="col" rowspan="2">Tanggal</th>
                <th scope="col" rowspan="2">
                  Jam <small class="text-muted">(${TIME_ZONE})</small>
                </th>
                <th scope="col" rowspan="2">
                  TMA ${
                    UNIT_DISPLAY == "mdpl"
                      ? ""
                      : `<small class="text-muted">(${UNIT_DISPLAY})</small>`
                  }
                </th>
                <th scope="col" rowspan="2">
                  Elevasi <small class="text-muted">(${
                    UNIT_DISPLAY == "m"
                      ? "mdpl"
                      : UNIT_DISPLAY == "cm"
                        ? "mdpl"
                        : UNIT_DISPLAY
                  })</small>
                </th>
                <th scope="col" rowspan="2">
                  Debit <small class="text-muted">(m3/s)</small>
                </th>

                <!-- BATERAI -->
                <th scope="col" colspan="2">Baterai</th>
              </tr>
              <tr>
                <th scope="col">Tegangan <small class="text-muted">(V)</small></th>
                <th scope="col">Kapasitas <small class="text-muted">(%)</small></th>
              </tr>
            `;
          } else {
            COLUMNS = [
              {
                data: "readingHour",
                name: "ReadingHour",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("D MMMM YYYY");
                },
              },
              {
                data: "readingHour",
                name: "ReadingHour",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("HH:mm");
                },
              },
              {
                data: "waterLevel",
                name: "WaterLevel",
                createdCell: function (td, cellData, rowData, row, col) {
                  if (IS_TMAT) {
                    return;
                  }

                  $(td).removeClass("bg-normal");
                  $(td).removeClass("bg-siaga3");
                  $(td).removeClass("bg-siaga2");
                  $(td).removeClass("bg-siaga1");
                  $(td).removeClass("bg-nostatus");

                  if (
                    rowData.unitSensor != "cmdpl" &&
                    rowData.unitSensor != "mdpl"
                  ) {
                    switch (rowData.warningStatus) {
                      case 0:
                        $(td).addClass("bg-normal");
                        break;

                      case 3:
                        $(td).addClass("bg-siaga3");
                        break;

                      case 2:
                        $(td).addClass("bg-siaga2");
                        break;

                      case 1:
                        $(td).addClass("bg-siaga1");
                        break;
                      default:
                        $(td).addClass("bg-nostatus");
                        break;
                    }
                  }
                },
                render: function (data) {
                  return `<strong>${formatNumber(data)}</strong>`;
                },
              },
              {
                data: "waterLevelSensor",
                name: "waterLevelSensor",
                render: function (data) {
                  if (data == null) {
                    return "-";
                  }
                  return formatNumber(data);
                },
              },
              {
                data: "debit",
                name: "Debit",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "batteryVoltage",
                name: "BatteryVoltage",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "batteryCapacity",
                name: "BatteryCapacity",
                render: function (data) {
                  return data;
                },
              },
            ];

            COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3] }];
            if (IS_TMAT) {
              $("#awlr-status-water").fadeOut(100);
              COLUMNS.pop();
              COLUMNDEF = [{ className: "dt-center", targets: [1, 2] }];
              HEADER_ROW = `
              <tr>
                <th scope="col" rowspan="2">Tanggal</th>
                <th scope="col" rowspan="2">
                  Jam <small class="text-muted">(${TIME_ZONE})</small>
                </th>
                <th scope="col" rowspan="2">
                  MAT <small class="text-muted">(${WELL_DEPTH_UNIT})</small>
                </th>

                <!-- BATERAI -->
                <th scope="col" colspan="2">Baterai</th>
              </tr>
              <tr>
                <th scope="col">Tegangan <small class="text-muted">(V)</small></th>
                <th scope="col">Kapasitas <small class="text-muted">(%)</small></th>
              </tr>
            `;
            } else {
              HEADER_ROW = `
              <tr>
                <th scope="col" rowspan="2">Tanggal</th>
                <th scope="col" rowspan="2">
                  Jam <small class="text-muted">(${TIME_ZONE})</small>
                </th>
                <th scope="col" rowspan="2">
                  TMA ${
                    UNIT_DISPLAY == "mdpl"
                      ? ""
                      : `<small class="text-muted">(${UNIT_DISPLAY})</small>`
                  }
                </th>
                <th scope="col" rowspan="2">
                  TMA Sensor ${
                    UNIT_DISPLAY == "mdpl"
                      ? ""
                      : `<small class="text-muted">(${UNIT_DISPLAY})</small>`
                  }
                </th>
                <th scope="col" rowspan="2">
                  Debit <small class="text-muted">(m3/s)</small>
                </th>

                <!-- BATERAI -->
                <th scope="col" colspan="2">Baterai</th>
              </tr>
              <tr>
                <th scope="col">Tegangan <small class="text-muted">(V)</small></th>
                <th scope="col">Kapasitas <small class="text-muted">(%)</small></th>
              </tr>
            `;
            }
          }
        } else if (OrganizationCode == "ORG084") {
          $("#awlr-status-water").fadeOut(100);

          COLUMNS = [
            {
              data: "readingHour",
              name: "ReadingHour",
              render: function (data, type, row) {
                return moment.parseZone(data).format("D MMMM YYYY");
              },
            },
            {
              data: "readingHour",
              name: "ReadingHour",
              render: function (data, type, row) {
                return moment.parseZone(data).format("HH:mm");
              },
            },
            {
              data: "waterLevel",
              name: "WaterLevel",
              createdCell: function (td, cellData, rowData, row, col) {
                if (IS_TMAT) {
                  return;
                }

                $(td).removeClass("bg-normal");
                $(td).removeClass("bg-siaga3");
                $(td).removeClass("bg-siaga2");
                $(td).removeClass("bg-siaga1");
                $(td).removeClass("bg-nostatus");

                if (
                  rowData.unitSensor != "cmdpl" &&
                  rowData.unitSensor != "mdpl"
                ) {
                  switch (rowData.warningStatus) {
                    case 0:
                      $(td).addClass("bg-normal");
                      break;

                    case 3:
                      $(td).addClass("bg-siaga3");
                      break;

                    case 2:
                      $(td).addClass("bg-siaga2");
                      break;

                    case 1:
                      $(td).addClass("bg-siaga1");
                      break;
                    default:
                      $(td).addClass("bg-nostatus");
                      break;
                  }
                }
              },
              render: function (data) {
                return `<strong>${formatNumber(data)}</strong>`;
              },
            },
            {
              data: "batteryVoltage",
              name: "BatteryVoltage",
              render: function (data) {
                return formatNumber(data);
              },
            },
            {
              data: "batteryCapacity",
              name: "BatteryCapacity",
              render: function (data) {
                return data;
              },
            },
          ];

          COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4] }];

          HEADER_ROW = `
                  <tr>
                    <th scope="col" rowspan="2">Tanggal</th>
                    <th scope="col" rowspan="2">Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                    <th scope="col" rowspan="2">
                      MAT <small class="text-muted">(${WELL_DEPTH_UNIT})</small>
                    </th>
                     <th scope="col" rowspan="2">
                      pH <small class="text-muted"></small>
                    </th>
                     <th scope="col" rowspan="2">
                      Suhu <small class="text-muted">(°C)</small>
                    </th>
                    <th scope="col" colspan="2">Baterai</th>
                  </tr>
                  <tr>
                    <th scope="col">Tegangan <small class="text-muted">(V)</small></th>
                    <th scope="col">Kapasitas <small class="text-muted">(%)</small></th>
                  </tr>
                `;
        } else {
          if (PEISCHAAL_ELEVATION) {
            COLUMNS = [
              {
                data: "readingHour",
                name: "ReadingHour",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("D MMMM YYYY");
                },
              },
              {
                data: "readingHour",
                name: "ReadingHour",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("HH:mm");
                },
              },
              {
                data: "waterLevel",
                name: "WaterLevel",
                createdCell: function (td, cellData, rowData, row, col) {
                  // if (IS_ONLY_MDPL) {
                  //   return;
                  // }

                  $(td).removeClass("bg-normal");
                  $(td).removeClass("bg-siaga3");
                  $(td).removeClass("bg-siaga2");
                  $(td).removeClass("bg-siaga1");
                  $(td).removeClass("bg-nostatus");

                  if (
                    rowData.unitSensor != "cmdpl" &&
                    rowData.unitSensor != "mdpl"
                  ) {
                    switch (rowData.warningStatus) {
                      case 0:
                        $(td).addClass("bg-normal");
                        break;

                      case 3:
                        $(td).addClass("bg-siaga3");
                        break;

                      case 2:
                        $(td).addClass("bg-siaga2");
                        break;

                      case 1:
                        $(td).addClass("bg-siaga1");
                        break;
                      default:
                        $(td).addClass("bg-nostatus");
                        break;
                    }
                  }
                },
                render: function (data) {
                  // if (IS_ONLY_MDPL) {
                  //   return null;
                  // }
                  return `<strong>${formatNumber(data)}</strong>`;
                },
              },
              {
                data: "waterLevelElevation",
                name: "WaterLevelelevation",
                createdCell: function (td, cellData, rowData, row, col) {
                  // if (!IS_ONLY_MDPL) {
                  //   return;
                  // }

                  $(td).removeClass("bg-normal");
                  $(td).removeClass("bg-siaga3");
                  $(td).removeClass("bg-siaga2");
                  $(td).removeClass("bg-siaga1");
                  $(td).removeClass("bg-nostatus");

                  if (
                    rowData.unitSensor != "cmdpl" &&
                    rowData.unitSensor != "mdpl"
                  ) {
                    // switch (rowData.warningStatus) {
                    //   case "Normal":
                    //     $(td).addClass("bg-normal");
                    //     break;
                    //   case "Siaga 3":
                    //     $(td).addClass("bg-siaga3");
                    //     break;
                    //   case "Siaga 2":
                    //     $(td).addClass("bg-siaga2");
                    //     break;
                    //   case "Siaga 1":
                    //     $(td).addClass("bg-siaga1");
                    //     break;
                    //   default:
                    //     $(td).addClass("bg-nostatus");
                    //     break;
                    // }
                  }
                },
                render: function (data) {
                  if (data == null) {
                    return "";
                  }
                  return `<strong>${formatNumber(data)}</strong>`;
                },
              },
              {
                data: "debit",
                name: "Debit",
                render: function (data) {
                  return formatNumber(data);
                },
              },
            ];
            COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4] }];
            HEADER_ROW = `<tr>
                        <th scope="col">Tanggal</th>
                        <th scope="col">Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                        <th scope="col">TMA ${
                          UNIT_DISPLAY == "mdpl"
                            ? ""
                            : `<small class="text-muted">(${UNIT_DISPLAY})</small>`
                        }</th>
                        <th scope="col">Elevasi <small class="text-muted">(${
                          UNIT_DISPLAY == "m"
                            ? "mdpl"
                            : UNIT_DISPLAY == "cm"
                              ? "mdpl"
                              : UNIT_DISPLAY
                        })</small> </th>
                        <th scope="col">Debit <small class="text-muted">(m3/s)</small></th>
                      </tr>`;
          } else {
            COLUMNS = [
              {
                data: "readingHour",
                name: "ReadingHour",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("D MMMM YYYY");
                },
              },
              {
                data: "readingHour",
                name: "ReadingHour",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("HH:mm");
                },
              },
              {
                data: "waterLevel",
                name: "WaterLevel",
                createdCell: function (td, cellData, rowData, row, col) {
                  if (IS_TMAT) {
                    return;
                  }

                  $(td).removeClass("bg-normal");
                  $(td).removeClass("bg-siaga3");
                  $(td).removeClass("bg-siaga2");
                  $(td).removeClass("bg-siaga1");
                  $(td).removeClass("bg-nostatus");

                  if (
                    rowData.unitSensor != "cmdpl" &&
                    rowData.unitSensor != "mdpl"
                  ) {
                    if (OrganizationCode == "ORG009" && cellData < 0) {
                      $(td).addClass("bg-awlr-minus");
                      return;
                    }
                    switch (rowData.warningStatus) {
                      case 0:
                        $(td).addClass("bg-normal");
                        break;

                      case 3:
                        $(td).addClass("bg-siaga3");
                        break;

                      case 2:
                        $(td).addClass("bg-siaga2");
                        break;

                      case 1:
                        $(td).addClass("bg-siaga1");
                        break;
                      default:
                        $(td).addClass("bg-nostatus");
                        break;
                    }
                  }
                },
                render: function (data) {
                  let note = "";
                  if (OrganizationCode == "ORG009" && data < 0) {
                    note =
                      '<br/><small class="text-muted fst-italic">*) Dibawah Mercu</small>';
                  }
                  return `<strong>${formatNumber(data)}</strong>${note}`;
                },
              },
              {
                data: "debit",
                name: "Debit",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "batteryVoltage",
                name: "BatteryVoltage",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "batteryCapacity",
                name: "BatteryCapacity",
                render: function (data) {
                  return data;
                },
              },
            ];

            COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3] }];
            if (IS_TMAT) {
              $("#awlr-status-water").fadeOut(100);

              COLUMNS = [
                {
                  data: "readingHour",
                  name: "ReadingHour",
                  render: function (data, type, row) {
                    return moment.parseZone(data).format("D MMMM YYYY");
                  },
                },
                {
                  data: "readingHour",
                  name: "ReadingHour",
                  render: function (data, type, row) {
                    return moment.parseZone(data).format("HH:mm");
                  },
                },
                {
                  data: "waterLevel",
                  name: "WaterLevel",
                  createdCell: function (td, cellData, rowData, row, col) {
                    if (IS_TMAT) {
                      return;
                    }

                    $(td).removeClass("bg-normal");
                    $(td).removeClass("bg-siaga3");
                    $(td).removeClass("bg-siaga2");
                    $(td).removeClass("bg-siaga1");
                    $(td).removeClass("bg-nostatus");

                    if (
                      rowData.unitSensor != "cmdpl" &&
                      rowData.unitSensor != "mdpl"
                    ) {
                      switch (rowData.warningStatus) {
                        case 0:
                          $(td).addClass("bg-normal");
                          break;

                        case 3:
                          $(td).addClass("bg-siaga3");
                          break;

                        case 2:
                          $(td).addClass("bg-siaga2");
                          break;

                        case 1:
                          $(td).addClass("bg-siaga1");
                          break;
                        default:
                          $(td).addClass("bg-nostatus");
                          break;
                      }
                    }
                  },
                  render: function (data) {
                    return `<strong>${formatNumber(data)}</strong>`;
                  },
                },
                {
                  data: "batteryVoltage",
                  name: "BatteryVoltage",
                  render: function (data) {
                    return formatNumber(data);
                  },
                },
                {
                  data: "batteryCapacity",
                  name: "BatteryCapacity",
                  render: function (data) {
                    return data;
                  },
                },
              ];

              COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4] }];

              HEADER_ROW = `
                  <tr>
                    <th scope="col" rowspan="2">Tanggal</th>
                    <th scope="col" rowspan="2">Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                    <th scope="col" rowspan="2">
                      MAT <small class="text-muted">(${WELL_DEPTH_UNIT})</small>
                    </th>
                    <th scope="col" colspan="2">Baterai</th>
                  </tr>
                  <tr>
                    <th scope="col">Tegangan <small class="text-muted">(V)</small></th>
                    <th scope="col">Kapasitas <small class="text-muted">(%)</small></th>
                  </tr>
                `;
            } else {
              HEADER_ROW = `
                <tr>
                  <th scope="col" rowspan="2">Tanggal</th>
                  <th scope="col" rowspan="2">Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                  <th scope="col" rowspan="2">
                    TMA ${
                      UNIT_DISPLAY == "mdpl"
                        ? ""
                        : `<small class="text-muted">(${UNIT_DISPLAY})</small>`
                    }
                  </th>
                  <th scope="col" rowspan="2">Debit <small class="text-muted">(m3/s)</small></th>
                  <th scope="col" colspan="2">Baterai</th>
                </tr>
                <tr>
                  <th scope="col">Tegangan <small class="text-muted">(V)</small></th>
                  <th scope="col">Kapasitas <small class="text-muted">(%)</small></th>
                </tr>
              `;
            }
          }
        }

        break;
      default:
        $("#awlr-telemetry-info").fadeIn(250);

        if (OrganizationCode == "ORG006") {
          if (PEISCHAAL_ELEVATION) {
            COLUMNS = [
              {
                data: "readingAt",
                name: "ReadingAt",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("D MMMM YYYY");
                },
              },
              {
                data: "readingAt",
                name: "ReadingAt",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("HH:mm");
                },
              },
              {
                data: "waterLevel",
                name: "WaterLevel",
                createdCell: function (td, cellData, rowData, row, col) {
                  // if (IS_ONLY_MDPL) {
                  //   return;
                  // }

                  $(td).removeClass("bg-normal");
                  $(td).removeClass("bg-siaga3");
                  $(td).removeClass("bg-siaga2");
                  $(td).removeClass("bg-siaga1");
                  $(td).removeClass("bg-nostatus");

                  if (
                    rowData.unitSensor != "cmdpl" &&
                    rowData.unitSensor != "mdpl"
                  ) {
                    switch (rowData.warningStatus) {
                      case 0:
                        $(td).addClass("bg-normal");
                        break;

                      case 3:
                        $(td).addClass("bg-siaga3");
                        break;

                      case 2:
                        $(td).addClass("bg-siaga2");
                        break;

                      case 1:
                        $(td).addClass("bg-siaga1");
                        break;
                      default:
                        $(td).addClass("bg-nostatus");
                        break;
                    }
                  }
                },
                render: function (data) {
                  // if (IS_ONLY_MDPL) {
                  //   return null;
                  // }
                  return `<strong>${formatNumber(data)}</strong>`;
                },
              },
              {
                data: "waterLevelSensor",
                name: "waterLevelSensor",
                render: function (data) {
                  if (data == null) {
                    return "-";
                  }

                  return data;
                },
              },
              {
                data: "waterLevelElevation",
                name: "WaterLevelelevation",
                createdCell: function (td, cellData, rowData, row, col) {
                  // if (!IS_ONLY_MDPL) {
                  //   return;
                  // }

                  $(td).removeClass("bg-normal");
                  $(td).removeClass("bg-siaga3");
                  $(td).removeClass("bg-siaga2");
                  $(td).removeClass("bg-siaga1");
                  $(td).removeClass("bg-nostatus");

                  if (
                    rowData.unitSensor != "cmdpl" &&
                    rowData.unitSensor != "mdpl"
                  ) {
                    switch (rowData.warningStatus) {
                      case 0:
                        $(td).addClass("bg-normal");
                        break;

                      case 3:
                        $(td).addClass("bg-siaga3");
                        break;

                      case 2:
                        $(td).addClass("bg-siaga2");
                        break;

                      case 1:
                        $(td).addClass("bg-siaga1");
                        break;
                      default:
                        $(td).addClass("bg-nostatus");
                        break;
                    }
                  }
                },
                render: function (data) {
                  if (data == null) {
                    return "";
                  }
                  return `<strong>${formatNumber(data)}</strong>`;
                },
              },
              {
                data: "changeStatus",
                name: "ChangeStatus",
                render: function (data, type, row) {
                  let result = "";

                  if (row.changeValue == 0) return "-";

                  if (data === "inc") {
                    result = `<span><i class="mdi mdi-arrow-up-circle text-danger font-weight-bold" style="font-size: 15px;"></i> ${row.changeValue} </span>`;
                  }
                  if (data === "dec") {
                    result = `<span><i class="mdi mdi-arrow-down-circle text-success font-weight-bold"
                                  style="font-size: 15px;"></i> ${row.changeValue} </span>`;
                  }
                  return result;
                },
              },
              {
                data: "debit",
                name: "Debit",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "batteryVoltage",
                name: "BatteryVoltage",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "batteryCapacity",
                name: "BatteryCapacity",
                render: function (data) {
                  return data;
                },
              },
            ];
            COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4] }];
            HEADER_ROW = `
                        <tr>
                          <th scope="col" rowspan="2">Tanggal</th>
                          <th scope="col" rowspan="2">
                            Jam <small class="text-muted">(${TIME_ZONE})</small>
                          </th>
                          <th scope="col" rowspan="2">
                            TMA <small class="text-muted">
                              ${
                                UNIT_DISPLAY == "mdpl"
                                  ? ""
                                  : `(${UNIT_DISPLAY})`
                              }
                            </small>
                          </th>
                          <th scope="col" rowspan="2">
                            TMA Sensor <small class="text-muted">
                              ${
                                UNIT_DISPLAY == "mdpl"
                                  ? ""
                                  : `(${UNIT_DISPLAY})`
                              }
                            </small>
                          </th>
                          <th scope="col" rowspan="2">
                            EMA <small class="text-muted">
                              ${UNIT_DISPLAY == "mdpl" ? "" : `(mdpl)`}
                            </small>
                          </th>
                          <th scope="col" rowspan="2">Perubahan</th>
                          <th scope="col" rowspan="2">
                            Debit <small class="text-muted">(m³/s)</small>
                          </th>
                          <th scope="col" colspan="2" class="text-center">Baterai</th>
                        </tr>
                        <tr>
                          <th scope="col">Tegangan (V)</th>
                          <th scope="col">Kapasitas (%)</th>
                        </tr>
                        `;
          } else {
            COLUMNS = [
              {
                data: "readingAt",
                name: "ReadingAt",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("D MMMM YYYY");
                },
              },
              {
                data: "readingAt",
                name: "ReadingAt",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("HH:mm");
                },
              },
              {
                data: "waterLevel",
                name: "WaterLevel",
                createdCell: function (td, cellData, rowData, row, col) {
                  if (IS_TMAT) {
                    return;
                  }

                  $(td).removeClass("bg-normal");
                  $(td).removeClass("bg-siaga3");
                  $(td).removeClass("bg-siaga2");
                  $(td).removeClass("bg-siaga1");
                  $(td).removeClass("bg-nostatus");

                  if (
                    rowData.unitSensor != "cmdpl" &&
                    rowData.unitSensor != "mdpl"
                  ) {
                    switch (rowData.warningStatus) {
                      case 0:
                        $(td).addClass("bg-normal");
                        break;

                      case 3:
                        $(td).addClass("bg-siaga3");
                        break;

                      case 2:
                        $(td).addClass("bg-siaga2");
                        break;

                      case 1:
                        $(td).addClass("bg-siaga1");
                        break;
                      default:
                        $(td).addClass("bg-nostatus");
                        break;
                    }
                  }
                },
                render: function (data) {
                  // if (IS_ONLY_MDPL) {
                  //   return null;
                  // }
                  return `<strong>${formatNumber(data)}</strong>`;
                },
              },
              {
                data: "waterLevelSensor",
                name: "waterLevelSensor",
                render: function (data) {
                  if (data == null) {
                    return "-";
                  }

                  return data;
                },
              },
              {
                data: "changeStatus",
                name: "ChangeStatus",
                render: function (data, type, row) {
                  let result = "";
                  if (data === "inc") {
                    result = `<span><i class="mdi mdi-arrow-up-circle text-danger font-weight-bold" style="font-size: 15px;"></i> ${row.changeValue} </span>`;
                  }
                  if (data === "dec") {
                    result = `<span><i class="mdi mdi-arrow-down-circle text-success font-weight-bold"
                                  style="font-size: 15px;"></i> ${row.changeValue} </span>`;
                  }
                  return result;
                },
              },
              {
                data: "debit",
                name: "Debit",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "batteryVoltage",
                name: "BatteryVoltage",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "batteryCapacity",
                name: "BatteryCapacity",
                render: function (data) {
                  return data;
                },
              },
            ];
            COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4] }];
            HEADER_ROW = `
            <tr>
              <th scope="col" rowspan="2">Tanggal</th>
              <th scope="col" rowspan="2">
                Jam <small class="text-muted">(${TIME_ZONE})</small>
              </th>
              <th scope="col" rowspan="2">
                TMA <small class="text-muted">
                  ${UNIT_DISPLAY == "mdpl" ? "" : `(${UNIT_DISPLAY})`}
                </small>
              </th>
              <th scope="col" rowspan="2">
                TMA Sensor <small class="text-muted">
                  ${UNIT_DISPLAY == "mdpl" ? "" : `(${UNIT_DISPLAY})`}
                </small>
              </th>
              <th scope="col" rowspan="2">Perubahan</th>
              <th scope="col" rowspan="2">
                Debit <small class="text-muted">(m³/s)</small>
              </th>
              <th scope="col" colspan="2" class="text-center">Battery</th>
            </tr>
            <tr>
              <th scope="col">Tegangan (V)</th>
              <th scope="col">Kapasitas (%)</th>
            </tr>
            `;

            if (IS_TMAT) {
              $("#awlr-status-water").fadeIn(100);
              COLUMNS.pop();
              COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3] }];
              HEADER_ROW = `
                <tr>
                  <th scope="col" rowspan="2">Tanggal</th>
                  <th scope="col" rowspan="2">
                    Jam <small class="text-muted">(${TIME_ZONE})</small>
                  </th>
                  <th scope="col" rowspan="2">
                    MAT <small class="text-muted">(${WELL_DEPTH_UNIT})</small>
                  </th>
                  <th scope="col" rowspan="2">
                    MAT Sensor <small class="text-muted">(${WELL_DEPTH_UNIT})</small>
                  </th>
                  <th scope="col" rowspan="2">Perubahan</th>
                  <th scope="col" colspan="2" class="text-center">Battery</th>
                </tr>
                <tr>
                  <th scope="col">Tegangan (V)</th>
                  <th scope="col">Kapasitas (%)</th>
                </tr>
                `;
            }
          }
        } else if (OrganizationCode == "ORG084") {
          $("#awlr-status-water").fadeOut(100);

          COLUMNS = [
            {
              data: "readingAt",
              name: "ReadingAt",
              render: function (data, type, row) {
                return moment.parseZone(data).format("D MMMM YYYY");
              },
            },
            {
              data: "readingAt",
              name: "ReadingAt",
              render: function (data, type, row) {
                return moment.parseZone(data).format("HH:mm");
              },
            },
            {
              data: "waterLevel",
              name: "WaterLevel",
              createdCell: function (td, cellData, rowData, row, col) {
                if (IS_TMAT) {
                  return;
                }

                $(td).removeClass("bg-normal");
                $(td).removeClass("bg-siaga3");
                $(td).removeClass("bg-siaga2");
                $(td).removeClass("bg-siaga1");
                $(td).removeClass("bg-nostatus");

                if (
                  rowData.unitSensor != "cmdpl" &&
                  rowData.unitSensor != "mdpl"
                ) {
                  switch (rowData.warningStatus) {
                    case 0:
                      $(td).addClass("bg-normal");
                      break;

                    case 3:
                      $(td).addClass("bg-siaga3");
                      break;

                    case 2:
                      $(td).addClass("bg-siaga2");
                      break;

                    case 1:
                      $(td).addClass("bg-siaga1");
                      break;
                    default:
                      $(td).addClass("bg-nostatus");
                      break;
                  }
                }
              },
              render: function (data) {
                // if (IS_ONLY_MDPL) {
                //   return null;
                // }
                return `<strong>${formatNumber(data)}</strong>`;
              },
            },
            {
              data: "ph",
              name: "ph",
              className: "text-center text-nowrap",
              render: function (data, type, row) {
                if (data != null) {
                  return `<span class="text-dark fw-semibold">${data}</span>`;
                }

                return "-";
              },
            },
            {
              data: "temperature",
              name: "temperature",
              className: "text-center text-nowrap",
              render: function (data, type, row) {
                if (data != null) {
                  return `<span class="text-dark fw-semibold">${data} <small class="text-muted"></small></span>`;
                }

                return "-";
              },
            },
            {
              data: "changeStatus",
              name: "ChangeStatus",
              render: function (data, type, row) {
                let result = "";
                if (data === "inc") {
                  result = `<span><i class="mdi mdi-arrow-up-circle text-danger font-weight-bold" style="font-size: 15px;"></i> ${row.changeValue} </span>`;
                }
                if (data === "dec") {
                  result = `<span><i class="mdi mdi-arrow-down-circle text-success font-weight-bold"
                                  style="font-size: 15px;"></i> ${row.changeValue} </span>`;
                }
                return result;
              },
            },

            {
              data: "batteryVoltage",
              name: "BatteryVoltage",
              render: function (data) {
                return formatNumber(data);
              },
            },
            {
              data: "batteryCapacity",
              name: "BatteryCapacity",
              render: function (data) {
                return data;
              },
            },
          ];

          COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3] }];
          HEADER_ROW = `
                <tr>
                  <th scope="col" rowspan="2">Tanggal</th>
                  <th scope="col" rowspan="2">
                    Jam <small class="text-muted">(${TIME_ZONE})</small>
                  </th>
                  <th scope="col" rowspan="2">
                    MAT <small class="text-muted">(${WELL_DEPTH_UNIT})</small>
                  </th>
                  <th scope="col" rowspan="2">
                    pH <small class="text-muted"></small>
                  </th>
                   <th scope="col" rowspan="2">
                    Suhu <small class="text-muted">(°C)</small>
                  </th>
                  <th scope="col" rowspan="2">Perubahan</th>
                  <th scope="col" colspan="2" class="text-center">Baterai</th>
                </tr>
                <tr>
                  <th scope="col">Tegangan (V)</th>
                  <th scope="col">Kapasitas (%)</th>
                </tr>
                `;
        } else {
          if (PEISCHAAL_ELEVATION) {
            COLUMNS = [
              {
                data: "readingAt",
                name: "ReadingAt",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("D MMMM YYYY");
                },
              },
              {
                data: "readingAt",
                name: "ReadingAt",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("HH:mm");
                },
              },
              {
                data: "waterLevel",
                name: "WaterLevel",
                createdCell: function (td, cellData, rowData, row, col) {
                  // if (IS_ONLY_MDPL) {
                  //   return;
                  // }

                  $(td).removeClass("bg-normal");
                  $(td).removeClass("bg-siaga3");
                  $(td).removeClass("bg-siaga2");
                  $(td).removeClass("bg-siaga1");
                  $(td).removeClass("bg-nostatus");

                  if (
                    rowData.unitSensor != "cmdpl" &&
                    rowData.unitSensor != "mdpl"
                  ) {
                    switch (rowData.warningStatus) {
                      case 0:
                        $(td).addClass("bg-normal");
                        break;

                      case 3:
                        $(td).addClass("bg-siaga3");
                        break;

                      case 2:
                        $(td).addClass("bg-siaga2");
                        break;

                      case 1:
                        $(td).addClass("bg-siaga1");
                        break;
                      default:
                        $(td).addClass("bg-nostatus");
                        break;
                    }
                  }
                },
                render: function (data) {
                  // if (IS_ONLY_MDPL) {
                  //   return null;
                  // }
                  return `<strong>${formatNumber(data)}</strong>`;
                },
              },
              {
                data: "waterLevelElevation",
                name: "WaterLevelelevation",
                createdCell: function (td, cellData, rowData, row, col) {
                  // if (!IS_ONLY_MDPL) {
                  //   return;
                  // }

                  $(td).removeClass("bg-normal");
                  $(td).removeClass("bg-siaga3");
                  $(td).removeClass("bg-siaga2");
                  $(td).removeClass("bg-siaga1");
                  $(td).removeClass("bg-nostatus");

                  if (
                    rowData.unitSensor != "cmdpl" &&
                    rowData.unitSensor != "mdpl"
                  ) {
                    switch (rowData.warningStatus) {
                      case 0:
                        $(td).addClass("bg-normal");
                        break;

                      case 3:
                        $(td).addClass("bg-siaga3");
                        break;

                      case 2:
                        $(td).addClass("bg-siaga2");
                        break;

                      case 1:
                        $(td).addClass("bg-siaga1");
                        break;
                      default:
                        $(td).addClass("bg-nostatus");
                        break;
                    }
                  }
                },
                render: function (data) {
                  if (data == null) {
                    return "";
                  }
                  return `<strong>${formatNumber(data)}</strong>`;
                },
              },
              {
                data: "changeStatus",
                name: "ChangeStatus",
                render: function (data, type, row) {
                  let result = "";

                  if (row.changeValue == 0) return "-";

                  if (data === "inc") {
                    result = `<span><i class="mdi mdi-arrow-up-circle text-danger font-weight-bold" style="font-size: 15px;"></i> ${row.changeValue} </span>`;
                  }
                  if (data === "dec") {
                    result = `<span><i class="mdi mdi-arrow-down-circle text-success font-weight-bold"
                                  style="font-size: 15px;"></i> ${row.changeValue} </span>`;
                  }
                  return result;
                },
              },
              {
                data: "debit",
                name: "Debit",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "batteryVoltage",
                name: "BatteryVoltage",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "batteryCapacity",
                name: "BatteryCapacity",
                render: function (data) {
                  return data;
                },
              },
            ];
            COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4] }];
            HEADER_ROW = `
            <tr>
              <th scope="col" rowspan="2">Tanggal</th>
              <th scope="col" rowspan="2">
                Jam <small class="text-muted">(${TIME_ZONE})</small>
              </th>
              <th scope="col" rowspan="2">
                TMA <small class="text-muted">
                  ${UNIT_DISPLAY == "mdpl" ? "" : `(${UNIT_DISPLAY})`}
                </small>
              </th>
              <th scope="col" rowspan="2">
                EMA <small class="text-muted">
                  ${UNIT_DISPLAY == "mdpl" ? "" : `(mdpl)`}
                </small>
              </th>
              <th scope="col" rowspan="2">Perubahan</th>
              <th scope="col" rowspan="2">
                Debit <small class="text-muted">(m³/s)</small>
              </th>
              <th scope="col" colspan="2" class="text-center">Battery</th>
            </tr>
            <tr>
              <th scope="col">Tegangan (V)</th>
              <th scope="col">Kapasitas (%)</th>
            </tr>
            `;
          } else {
            COLUMNS = [
              {
                data: "readingAt",
                name: "ReadingAt",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("D MMMM YYYY");
                },
              },
              {
                data: "readingAt",
                name: "ReadingAt",
                render: function (data, type, row) {
                  return moment.parseZone(data).format("HH:mm");
                },
              },
              {
                data: "waterLevel",
                name: "WaterLevel",
                createdCell: function (td, cellData, rowData, row, col) {
                  if (IS_TMAT) {
                    return;
                  }

                  $(td).removeClass("bg-normal");
                  $(td).removeClass("bg-siaga3");
                  $(td).removeClass("bg-siaga2");
                  $(td).removeClass("bg-siaga1");
                  $(td).removeClass("bg-nostatus");

                  if (
                    rowData.unitSensor != "cmdpl" &&
                    rowData.unitSensor != "mdpl"
                  ) {
                    if (OrganizationCode == "ORG009" && cellData < 0) {
                      $(td).addClass("bg-awlr-minus");
                      return;
                    }
                    switch (rowData.warningStatus) {
                      case 0:
                        $(td).addClass("bg-normal");
                        break;

                      case 3:
                        $(td).addClass("bg-siaga3");
                        break;

                      case 2:
                        $(td).addClass("bg-siaga2");
                        break;

                      case 1:
                        $(td).addClass("bg-siaga1");
                        break;
                      default:
                        $(td).addClass("bg-nostatus");
                        break;
                    }
                  }
                },
                render: function (data) {
                  // if (IS_ONLY_MDPL) {
                  //   return null;
                  // }
                  let note = "";
                  if (OrganizationCode == "ORG009" && data < 0) {
                    note =
                      '<br/><small class="text-muted fst-italic">*) Dibawah Mercu</small>';
                  }

                  return `<strong>${formatNumber(data)}</strong>${note}`;
                },
              },
              {
                data: "changeStatus",
                name: "ChangeStatus",
                render: function (data, type, row) {
                  let result = "";
                  if (data === "inc") {
                    result = `<span><i class="mdi mdi-arrow-up-circle text-danger font-weight-bold" style="font-size: 15px;"></i> ${row.changeValue} </span>`;
                  }
                  if (data === "dec") {
                    result = `<span><i class="mdi mdi-arrow-down-circle text-success font-weight-bold"
                                  style="font-size: 15px;"></i> ${row.changeValue} </span>`;
                  }
                  return result;
                },
              },
              {
                data: "debit",
                name: "Debit",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "batteryVoltage",
                name: "BatteryVoltage",
                render: function (data) {
                  return formatNumber(data);
                },
              },
              {
                data: "batteryCapacity",
                name: "BatteryCapacity",
                render: function (data) {
                  return data;
                },
              },
            ];
            COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4] }];
            HEADER_ROW = `
            <tr>
              <th scope="col" rowspan="2">Tanggal</th>
              <th scope="col" rowspan="2">
                Jam <small class="text-muted">(${TIME_ZONE})</small>
              </th>
              <th scope="col" rowspan="2">
                TMA <small class="text-muted">
                  ${UNIT_DISPLAY == "mdpl" ? "" : `(${UNIT_DISPLAY})`}
                </small>
              </th>
              <th scope="col" rowspan="2">Perubahan</th>
              <th scope="col" rowspan="2">
                Debit <small class="text-muted">(m³/s)</small>
              </th>
              <th scope="col" colspan="2" class="text-center">Baterai</th>
            </tr>
            <tr>
              <th scope="col">Tegangan (V)</th>
              <th scope="col">Kapasitas (%)</th>
            </tr>
            `;

            if (IS_TMAT) {
              $("#awlr-status-water").fadeIn(100);

              COLUMNS = [
                {
                  data: "readingAt",
                  name: "ReadingAt",
                  render: function (data, type, row) {
                    return moment.parseZone(data).format("D MMMM YYYY");
                  },
                },
                {
                  data: "readingAt",
                  name: "ReadingAt",
                  render: function (data, type, row) {
                    return moment.parseZone(data).format("HH:mm");
                  },
                },
                {
                  data: "waterLevel",
                  name: "WaterLevel",
                  createdCell: function (td, cellData, rowData, row, col) {
                    if (IS_TMAT) {
                      return;
                    }

                    $(td).removeClass("bg-normal");
                    $(td).removeClass("bg-siaga3");
                    $(td).removeClass("bg-siaga2");
                    $(td).removeClass("bg-siaga1");
                    $(td).removeClass("bg-nostatus");

                    if (
                      rowData.unitSensor != "cmdpl" &&
                      rowData.unitSensor != "mdpl"
                    ) {
                      switch (rowData.warningStatus) {
                        case 0:
                          $(td).addClass("bg-normal");
                          break;

                        case 3:
                          $(td).addClass("bg-siaga3");
                          break;

                        case 2:
                          $(td).addClass("bg-siaga2");
                          break;

                        case 1:
                          $(td).addClass("bg-siaga1");
                          break;
                        default:
                          $(td).addClass("bg-nostatus");
                          break;
                      }
                    }
                  },
                  render: function (data) {
                    // if (IS_ONLY_MDPL) {
                    //   return null;
                    // }
                    return `<strong>${formatNumber(data)}</strong>`;
                  },
                },

                {
                  data: "changeStatus",
                  name: "ChangeStatus",
                  render: function (data, type, row) {
                    let result = "";
                    if (data === "inc") {
                      result = `<span><i class="mdi mdi-arrow-up-circle text-danger font-weight-bold" style="font-size: 15px;"></i> ${row.changeValue} </span>`;
                    }
                    if (data === "dec") {
                      result = `<span><i class="mdi mdi-arrow-down-circle text-success font-weight-bold"
                                  style="font-size: 15px;"></i> ${row.changeValue} </span>`;
                    }
                    return result;
                  },
                },

                {
                  data: "batteryVoltage",
                  name: "BatteryVoltage",
                  render: function (data) {
                    return formatNumber(data);
                  },
                },
                {
                  data: "batteryCapacity",
                  name: "BatteryCapacity",
                  render: function (data) {
                    return data;
                  },
                },
              ];

              COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3] }];
              HEADER_ROW = `
                <tr>
                  <th scope="col" rowspan="2">Tanggal</th>
                  <th scope="col" rowspan="2">
                    Jam <small class="text-muted">(${TIME_ZONE})</small>
                  </th>
                  <th scope="col" rowspan="2">
                    MAT <small class="text-muted">(${WELL_DEPTH_UNIT})</small>
                  </th>
                  <th scope="col" rowspan="2">Perubahan</th>
                  <th scope="col" colspan="2" class="text-center">Baterai</th>
                </tr>
                <tr>
                  <th scope="col">Tegangan (V)</th>
                  <th scope="col">Kapasitas (%)</th>
                </tr>
                `;
            }
          }
        }
    }

    var agwlrElevColIndex = -1;
    if (IS_TMAT && (timeCategory === "minute" || timeCategory === "hour")) {
      agwlrElevColIndex = appendAgwlrElevMatColumn(COLUMNS);
      if (agwlrElevColIndex >= 0) {
        HEADER_ROW = injectAgwlrElevMatHeader(HEADER_ROW);
        COLUMNDEF = mergeAgwlrElevColumnDef(COLUMNDEF, agwlrElevColIndex);
      }
    }

    var minuteMeta = prepareMinuteRowMeta(
      COLUMNS,
      COLUMNDEF,
      HEADER_ROW,
      timeCategory,
    );
    COLUMNS = minuteMeta.columns;
    COLUMNDEF = minuteMeta.columnDef;
    HEADER_ROW = minuteMeta.headerRow;
    if (
      minuteMeta.applied &&
      typeof agwlrElevColIndex === "number" &&
      agwlrElevColIndex >= 0
    ) {
      agwlrElevColIndex += 1;
    }

    $(`#${idTable} thead`).html(HEADER_ROW);
    $(`#${idTable}`).DataTable(withMinuteRowCount({
      dom: "rti",
      paging: false,
      ordering: false,
      processing: true,
      serverSide: true,
      ajax: {
        url: STATION_URL,
        type: "POST",
        data: {
          stationId: STATION_ID,
          deviceId: DEVICE_ID,
          filterDate: filterDate,
          selectedTime: timeCategory,
          stationType: STATION_TYPE,
        },
        dataSrc: function (json) {
          if (agwlrElevColIndex >= 0) {
            var hasElev = dataHasWaterLevelElevation(json.data);
            var table = $(`#${idTable}`).DataTable();
            if (table) {
              table.column(agwlrElevColIndex).visible(hasElev);
            }
          }
          return json.data;
        },
      },
      columnDefs: COLUMNDEF,
      columns: COLUMNS,
    }, timeCategory, filterDate, minuteMeta.applied));
  }

  if (typePos == EnumStationType.WaterQuality) {
    var wqEnabled =
      window.WqmsSensorUtils && window.WqmsSensorUtils.getEnabledSensorKeys
        ? window.WqmsSensorUtils.getEnabledSensorKeys()
        : [
            "temperature",
            "ph",
            "orp",
            "turbidity",
            "cod",
            "salinity",
            "waterLevel",
          ];
    var wqCfg =
      window.WqmsSensorUtils && window.WqmsSensorUtils.buildWqmsDatatableConfig
        ? window.WqmsSensorUtils.buildWqmsDatatableConfig(
            timeCategory,
            wqEnabled,
            TIME_ZONE,
            USE_BATTERY_COLUMN,
          )
        : null;
    if (wqCfg) {
      COLUMNS = wqCfg.columns;
      COLUMNDEF = wqCfg.columnDef;
      HEADER_ROW = wqCfg.headerRow;
    }

    var minuteMeta = prepareMinuteRowMeta(
      COLUMNS,
      COLUMNDEF,
      HEADER_ROW,
      timeCategory,
    );
    COLUMNS = minuteMeta.columns;
    COLUMNDEF = minuteMeta.columnDef;
    HEADER_ROW = minuteMeta.headerRow;
    if (
      minuteMeta.applied &&
      typeof agwlrElevColIndex === "number" &&
      agwlrElevColIndex >= 0
    ) {
      agwlrElevColIndex += 1;
    }

    $(`#${idTable} thead`).html(HEADER_ROW);
    $(`#${idTable}`).DataTable(withMinuteRowCount({
      dom: "rti",
      paging: false,
      ordering: false,
      processing: true,
      serverSide: true,
      ajax: {
        url: STATION_URL,
        type: "POST",
        data: {
          stationId: STATION_ID,
          deviceId: DEVICE_ID,
          filterDate: filterDate,
          selectedTime: timeCategory,
          stationType: STATION_TYPE,
        },
      },
      columnDefs: COLUMNDEF,
      columns: COLUMNS,
    }, timeCategory, filterDate, minuteMeta.applied));
  }

  if (typePos == EnumStationType.AWS) {
    let flag = 0;

    switch (timeCategory) {
      case "minute":
        $("#arr-telemetry-info").fadeOut(150);
        COLUMNS = [
          {
            data: "readingAt",
            name: "ReadingAt",
            className: "text-center text-nowrap",
            render: function (data) {
              if (!data) return "";
              return moment.parseZone(data).locale("id").format("D MMMM YYYY");
            },
          },
          {
            data: "readingAt",
            name: "ReadingAt",
            render: function (data) {
              if (!data) return "";
              return moment.parseZone(data).locale("id").format("HH:mm");
            },
          },
        ];

        // Inisialisasi Header dengan Rowspan 2 untuk Tanggal dan Jam
        let head1 = `<tr>
                      <th rowspan="2" class="text-center" style="vertical-align: middle">Tanggal</th>
                      <th rowspan="2" class="text-center" style="vertical-align: middle">Jam</th>`;
        let head2 = `<tr>`;

        sensorNames.forEach((sensor) => {
          let obj = awsSensors[sensor];
          // Push Kolom Sensor Biasa
          COLUMNS.push({
            data: sensor,
            name: capitalizeFirstLetter(sensor),
            render: function (data, type, row) {
              switch (sensor) {
                case "humidity":
                  return `<span class="text-dark fw-semibold">${data}%</span><br/><small class="text-muted">${row.humidityStatus}</small>`;
                case "windDirection":
                  return `<span class="text-dark fw-semibold">${data}&deg;</span><br/>
                          <small class="d-flex justify-content-center align-items-center text-muted">
                              <span style="transform: rotate(${data}deg);"><i class="mdi mdi-navigation"></i></span>
                              <span class="ms-1">${row.windDirectionStatus}</span>
                          </small>`;
                default:
                  return `<strong>${data}</strong>`;
              }
            },
          });

          // Tambah ke Header 1 dengan Rowspan 2
          head1 += `<th rowspan="2" class="text-center" style="vertical-align: middle">${capitalizeFirstLetter(obj.sensorName)} </br> <small class="text-muted">(${obj.unit})</small></th>`;
        });

        // TAMBAHKAN KOLOM BATERAI DI SINI
        head1 += `<th colspan="2" class="text-center" style="vertical-align: middle">Baterai</th>`;
        head2 += `<th class="text-center">Tegangan (V)</th><th class="text-center">Kapasitas (%)</th>`;

        COLUMNS.push(
          {
            data: "batteryVoltage",
            name: "batteryVoltage",
            render: (data) => `<strong>${data || "-"}</strong>`,
          },
          {
            data: "batteryCapacity",
            name: "batteryCapacity",
            render: (data) => `<strong>${data || "-"}</strong>`,
          },
        );

        HEADER_ROW = head1 + "</tr>" + head2 + "</tr>";
        break;
      case "day":
        $("#arr-telemetry-info").fadeIn(150);
        COLUMNS = [
          {
            data: "readingDate",
            name: "readingDate",
            className: "text-center text-nowrap",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "";
              return moment.parseZone(data).locale("id").format("D MMMM YYYY");
            },
          },
        ];

        let tempColums = [];

        HEADER_ROW = `<tr>
                        <th class="text-center" style="vertical-align: middle">Tanggal</th>
                        `;

        let header1 = `<tr>
                        <th rowspan="2" class="text-center" style="vertical-align: middle">Tanggal</th>`;
        let header2 = "<tr>";

        sensorNames.forEach((sensor) => {
          let obj = awsSensors[sensor];

          if (sensor == "rainfall") {
            COLUMNS.push({
              data: sensor,
              name: capitalizeFirstLetter(sensor),
              createdCell: function (td, cellData, rowData, row, col) {
                $("#arr-telemetry-info").fadeIn(250);
                switch (rowData.intensity) {
                  case 0:
                    intensity = "Tidak ada Hujan";
                    $(td).addClass("bg-berawan");
                    break;
                  case 1:
                    intensity = "Hujan Ringan";
                    $(td).addClass("bg-hujan-ringan");
                    break;
                  case 2:
                    intensity = "Hujan Sedang";
                    $(td).addClass("bg-hujan-sedang");
                    break;
                  case 3:
                    intensity = "Hujan Lebat";
                    $(td).addClass("bg-hujan-lebat");
                    break;
                  case 4:
                    intensity = "Hujan sangat Lebat";
                    $(td).addClass("bg-hujan-sangat-lebat");
                    break;
                  default:
                    intensity = "";
                    break;
                }
              },
              render: function (data, type, row) {
                if (data == "" ?? data == null ?? data == undefined)
                  return "<b>-</b>";
                return `<span class="text-dark fw-semibold">${data}</span><br/><small style="color: #555555;font-weight:500;">${getIntensityIcon(
                  row.intensity,
                )}</small>`;
              },
            });

            const colRainfall = [
              {
                data: sensor,
                name: capitalizeFirstLetter(sensor),
              },
              {
                data: "intensity",
                name: capitalizeFirstLetter("intensity"),
                render: function (data) {
                  switch (data) {
                    case 0:
                      return "Tidak ada Hujan";
                    case 1:
                      return "Hujan Ringan";
                    case 2:
                      return "Hujan Sedang";
                    case 3:
                      return "Hujan Lebat";
                    case 4:
                      return "Hujan Sangat Lebat";
                    default:
                      return "Tidak ada Hujan";
                  }
                },
              },
            ];

            tempColums.push(...colRainfall);
          } else if (sensor == "evaporation") {
            const colEvaporation = [
              {
                data: "evaporationTotal",
                name: "evaporationTotal",
              },
            ];
            tempColums.push(...colEvaporation);
          } else if (sensor == "solarRadiation") {
            const colSolarRadiation = [
              {
                data: "solarRadiationMin",
                name: "SolarRadiationMin",
              },
              {
                data: "solarRadiationMax",
                name: "SolarRadiationMax",
              },
              {
                data: "solarRadiation",
                name: "SolarRadiation",
              },
              {
                data: "sunshineHour",
                name: "SunshineHour",
                render: function (data) {
                  if (data == 0) return 0;
                  if (data == "" ?? data == null ?? data == undefined)
                    return "<b>-</b>";
                  return `<strong>${formatNumber(data)}</strong>`;
                },
              },
            ];

            tempColums.push(...colSolarRadiation);
          } else if (sensor == "windDirection") {
            // Wind Direction: hanya 1 kolom Arah Angin Dominan
            let colName = sensor;

            COLUMNS.push({
              data: "windDirectionDominant",
              name: capitalizeFirstLetter(colName),
              render: function (data, type, row) {
                if (
                  row.windDirectionDominant == "" ??
                  row.windDirectionDominant == null ??
                  row.windDirectionDominant == undefined
                )
                  return "<b>-</b>";
                return `<span class="text-dark fw-semibold">${row.windDirectionDominant}&deg;</span><br/>
                    <small class="d-flex justify-content-center align-items-center text-muted">
                        <span style="transform: rotate(${row.windDirectionDominant}deg);"><i class="mdi mdi-navigation"></i></span>
                        <span class="ms-1">${row.windDirectionDominantStatus}</span>
                    </small>`;
              },
            });

            const colWindDirection = [
              {
                data: "windDirectionDominant",
                name: capitalizeFirstLetter(colName),
                render: function (data, type, row) {
                  console.log(row);
                  if (data == null ?? data == undefined) return "<b>-</b>";
                  return `<span class="text-dark fw-semibold">${data}&deg;</span><br/>
                    <small class="d-flex justify-content-center align-items-center text-muted">
                        <span style="transform: rotate(${data}deg);"><i class="mdi mdi-navigation"></i></span>
                        <span class="ms-1">${row.windDirectionDominantStatus}</span>
                    </small>`;
                },
              },
            ];

            tempColums.push(...colWindDirection);
          } else if (sensor == "windSpeed") {
            // Wind Speed: hanya 1 kolom Kecepatan Angin
            let colName = sensor;

            COLUMNS.push({
              data: colName,
              name: capitalizeFirstLetter(colName),
              render: function (data, type, row) {
                if (data == "" ?? data == null ?? data == undefined)
                  return "<b>-</b>";
                return `<strong>${data}</strong>`;
              },
            });

            const colWindSpeed = [
              {
                data: colName,
                name: capitalizeFirstLetter(colName),
              },
            ];

            tempColums.push(...colWindSpeed);
          } else {
            let colName = sensor;

            if (sensor != "battery") {
              COLUMNS.push({
                data: colName,
                name: capitalizeFirstLetter(colName),
                render: function (data, type, row) {
                  if (data == "" ?? data == null ?? data == undefined)
                    return "<b>-</b>";

                  switch (sensor) {
                    case "humidity":
                      return `<span class="text-dark fw-semibold">${data}%</span>`;
                    default:
                      return `<strong>${data}</strong>`;
                  }
                },
              });

              const colSensor = [
                {
                  data: `${colName}Min`,
                  name: capitalizeFirstLetter(`${colName}Min`),
                },
                {
                  data: `${colName}Max`,
                  name: capitalizeFirstLetter(`${colName}Max`),
                },
                {
                  data: colName,
                  name: capitalizeFirstLetter(colName),
                },
              ];

              tempColums.push(...colSensor);
            }
          }

          // Header generation
          if (sensor != "battery") {
            HEADER_ROW += `<th class="text-center" style="vertical-align: middle">${capitalizeFirstLetter(
              awsSensors[sensor].sensorName,
            )} </br> <small class="text-muted">(${obj.unit})</small></th>`;

            if (sensor == "rainfall") {
              header1 += `<th colspan="2" class="text-center" style="vertical-align: middle">${capitalizeFirstLetter(
                awsSensors[sensor].sensorName,
              )} </br> <small class="text-muted">(${obj.unit})</small></th>`;
              header2 += `<th class="text-center" style="vertical-align: middle"> CH </th>
                          <th class="text-center" style="vertical-align: middle"> Intensitas </th>`;
            } else if (sensor == "evaporation") {
              header1 += `<th rowspan='2' class="text-center" style="vertical-align: middle">Total Penguapan </br> <small class="text-muted">(mm/hari)</small></th>`;
            } else if (sensor == "solarRadiation") {
              header1 += `<th colspan="4" class="text-center" style="vertical-align: middle">Radiasi Matahari </br> <small class="text-muted">(W/s<sup>2</sup>)</small></th>`;
              header2 += `<th class="text-center" style="vertical-align: middle"> Min. </th>
                          <th class="text-center" style="vertical-align: middle"> Maks. </th>
                          <th class="text-center" style="vertical-align: middle"> Rerata </th>
                          <th class="text-center" style="vertical-align: middle"> Lama Penyinaran <br/><small class="text-muted">(jam)</small></th>`;
            } else if (sensor == "windDirection") {
              header1 += `<th rowspan='2' class="text-center" style="vertical-align: middle">Arah Angin Dominan </br> <small class="text-muted">(&deg)</small></th>`;
            } else if (sensor == "windSpeed") {
              header1 += `<th rowspan='2' class="text-center" style="vertical-align: middle">Kecepatan Angin </br> <small class="text-muted">(km/hari)</small></th>`;
            } else {
              header1 += `<th colspan="3" class="text-center" style="vertical-align: middle">${capitalizeFirstLetter(
                awsSensors[sensor].sensorName,
              )} </br> <small class="text-muted">(${obj.unit})</small></th>`;
              header2 += `<th class="text-center" style="vertical-align: middle"> Min. </th>
                          <th class="text-center" style="vertical-align: middle"> Maks. </th>
                          <th class="text-center" style="vertical-align: middle"> Rerata </th>`;
            }
          }
        });

        HEADER_ROW += "</tr>";
        header1 += "</tr>";
        header2 += "</tr>";

        header1 += header2;

        HEADER_ROW = header1;

        let finalCols = tempColums.unshift({
          data: "readingDate",
          name: "readingDate",
          className: "text-center text-nowrap",
          render: function (data, type, row) {
            if (data == "" ?? data == null ?? data == undefined) return "";
            return moment.parseZone(data).locale("id").format("D MMMM YYYY");
          },
        });

        COLUMNS = tempColums;

        break;
      default:
        $("#arr-telemetry-info").fadeIn(150);
        COLUMNS = [
          {
            data: "readingHour",
            name: "ReadingHour",
            className: "text-center text-nowrap",
            render: function (data) {
              if (!data) return "";
              return moment.parseZone(data).locale("id").format("D MMMM YYYY");
            },
          },
          {
            data: "readingHour",
            name: "ReadingHour",
            render: function (data) {
              if (!data) return "";
              return moment.parseZone(data).locale("id").format("HH:mm");
            },
          },
        ];

        let defHead1 = `<tr>
                          <th rowspan="2" class="text-center" style="vertical-align: middle">Tanggal</th>
                          <th rowspan="2" class="text-center" style="vertical-align: middle">Jam</th>`;
        let defHead2 = `<tr>`;

        sensorNames.forEach((sensor) => {
          let obj = awsSensors[sensor];

          if (sensor == "solarRadiation") {
            defHead1 += `<th rowspan="2" class="text-center" style="vertical-align: middle">${capitalizeFirstLetter(obj.sensorName)} </br> <small class="text-muted">(${obj.unit})</small></th>`;

            COLUMNS.push({
              data: sensor,
              name: capitalizeFirstLetter(sensor),
              render: function (data) {
                if (data == "" ?? data == null ?? data == undefined)
                  return "<b>-</b>";
                return `<strong>${data}</strong>`;
              },
            });
          } else {
            defHead1 += `<th rowspan="2" class="text-center" style="vertical-align: middle">${capitalizeFirstLetter(obj.sensorName)} </br> <small class="text-muted">(${obj.unit})</small></th>`;

            COLUMNS.push({
              data: sensor,
              name: capitalizeFirstLetter(sensor),
              render: function (data, type, row) {
                switch (sensor) {
                  case "humidity":
                    return `<span class="text-dark fw-semibold">${data}%</span><br/><small class="text-muted">${row.humidityStatus || ""}</small>`;
                  case "windDirection":
                    return `<span class="text-dark fw-semibold">${data}&deg;</span><br/>
                            <small class="d-flex justify-content-center align-items-center text-muted">
                                <span style="transform: rotate(${data}deg);"><i class="mdi mdi-navigation"></i></span>
                                <span class="ms-1">${row.windDirectionStatus || ""}</span>
                            </small>`;
                  default:
                    return `<strong>${data ?? "-"}</strong>`;
                }
              },
            });
          }
        });

        // TAMBAHKAN KOLOM BATERAI
        defHead1 += `<th colspan="2" class="text-center" style="vertical-align: middle">Baterai</th>`;
        defHead2 += `<th class="text-center">Tegangan (V)</th><th class="text-center">Kapasitas (%)</th>`;

        COLUMNS.push(
          {
            data: "batteryVoltage",
            name: "batteryVoltage",
            render: (data) => `<strong>${data || "-"}</strong>`,
          },
          {
            data: "batteryCapacity",
            name: "batteryCapacity",
            render: (data) => `<strong>${data || "-"}</strong>`,
          },
        );

        HEADER_ROW = defHead1 + "</tr>" + defHead2 + "</tr>";
        break;
    }

    var minuteMeta = prepareMinuteRowMeta(
      COLUMNS,
      COLUMNDEF,
      HEADER_ROW,
      timeCategory,
    );
    COLUMNS = minuteMeta.columns;
    COLUMNDEF = minuteMeta.columnDef;
    HEADER_ROW = minuteMeta.headerRow;
    if (
      minuteMeta.applied &&
      typeof agwlrElevColIndex === "number" &&
      agwlrElevColIndex >= 0
    ) {
      agwlrElevColIndex += 1;
    }

    $(`#${idTable} thead`).html(HEADER_ROW);
    $(`#${idTable}`).DataTable(withMinuteRowCount({
      dom: "rti",
      paging: false,
      ordering: false,
      processing: true,
      serverSide: true,
      scrollX: false,
      ajax: {
        url: STATION_URL,
        type: "POST",
        data: {
          stationId: STATION_ID,
          deviceId: DEVICE_ID,
          filterDate: filterDate,
          selectedTime: timeCategory,
          stationType: STATION_TYPE,
        },
      },
      columnDefs: COLUMNDEF,
      columns: COLUMNS,
      language: {
        emptyTable: function () {
          const currentHour = parseInt(moment().format("HH"));
          if (filterDate === moment().format("YYYY-MM-DD") && currentHour < 7) {
            return `Data yang tersedia pada tanggal ${moment(filterDate).format(
              "D MMMM YYYY",
            )} dimulai pukul 07:00 Pagi`;
          } else {
            return "No data available";
          }
        },
      },
    }, timeCategory, filterDate, minuteMeta.applied));
  }

  if (typePos == EnumStationType.VNotch) {
    switch (timeCategory) {
      case "day":
        COLUMNS = [
          {
            data: "readingDate",
            name: "readingDate",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "";
              return moment.parseZone(data).locale("id").format("D MMMM YYYY");
            },
          },
          {
            data: "waterLevelAvg",
            name: "WaterLevelAvg",
            render: function (data) {
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "waterLevelMin",
            name: "WaterLevelMin",
            render: function (data) {
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "waterLevelMax",
            name: "WaterLevelMax",
            render: function (data) {
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "debitAvg",
            name: "DebitAvg",
            render: function (data) {
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "debitMin",
            name: "DebitMin",
            render: function (data) {
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "debitMax",
            name: "DebitMax",
            render: function (data) {
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
        ];

        COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4, 5, 6] }];

        HEADER_ROW = ` <tr>
                      <th>Tanggal</th>
                      <th>TMA Rerata <small class="text-muted">(cm)</small> </th>
                      <th>TMA Minimum <small class="text-muted">(cm)</small></th>
                      <th>TMA Maksimum <small class="text-muted">(cm)</small></th>
                      <th>Debit Rerata <small class="text-muted">(L/s)</small></th>
                      <th>Debit Minimum <small class="text-muted">(L/s)</small></th>
                      <th>Debit Maksimum <small class="text-muted">(L/s)</small></th>
                    </tr>`;
        break;
      case "hour":
        COLUMNS = [
          {
            data: "readingHour",
            name: "ReadingHour",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "";
              return moment.parseZone(data).locale("id").format("D MMMM YYYY");
            },
          },
          {
            data: "readingHour",
            name: "ReadingHour",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "";
              return moment.parseZone(data).locale("id").format("HH:mm");
            },
          },
          {
            data: "waterLevel",
            name: "WaterLevel",
            render: function (data) {
              // if (IS_ONLY_MDPL) {
              //   return null;
              // }
              return `<strong>${formatNumber(data)} cm</strong>`;
            },
          },
          {
            data: "changeStatus",
            name: "ChangeStatus",
            render: function (data, type, row) {
              let result = "";
              if (data === "inc") {
                result = `<span><i class="mdi mdi-arrow-up-circle text-danger font-weight-bold" style="font-size: 15px;"></i> ${row.changeValue} </span>`;
              }
              if (data === "dec") {
                result = `<span><i class="mdi mdi-arrow-down-circle text-success font-weight-bold"
                                style="font-size: 15px;"></i> ${row.changeValue} </span>`;
              }
              return result;
            },
          },
          {
            data: "debit",
            name: "Debit",
            render: function (data) {
              if (data == null) {
                return "";
              }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },

          {
            data: "battery",
            name: "Battery",
            render: function (data, type, row) {
              if (data == null) {
                return "";
              }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
        ];
        COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4, 5] }];
        HEADER_ROW = `<tr>
                      <th>Tanggal</th>
                      <th>Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                      <th>TMA <small class="text-muted">(cm)</small></th>
                      <th>Perubahan </th>
                      <th>Debit <small class="text-muted">(L/s)</small></th>
                      <th>Baterai <small class="text-muted">(v)</small></th>
                    </tr>`;

        if (!USE_BATTERY_COLUMN) {
          COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4] }];
          HEADER_ROW = `<tr>
                      <th>Tanggal</th>
                      <th>Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                      <th>TMA <small class="text-muted">(cm)</small></th>
                      <th>Perubahan </th>
                      <th>Debit <small class="text-muted">(L/s)</small></th>
                    </tr>`;
          COLUMNS = COLUMNS.filter(function (item) {
            return item.name !== "Battery";
          });
        }

        break;
      default:
        COLUMNS = [
          {
            data: "readingAt",
            name: "ReadingAt",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "";
              return moment.parseZone(data).locale("id").format("D MMMM YYYY");
            },
          },
          {
            data: "readingAt",
            name: "ReadingAt",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "";
              return moment.parseZone(data).locale("id").format("HH:mm");
            },
          },
          {
            data: "waterLevel",
            name: "WaterLevel",
            render: function (data) {
              // if (IS_ONLY_MDPL) {
              //   return null;
              // }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "changeStatus",
            name: "ChangeStatus",
            render: function (data, type, row) {
              let result = "";
              if (data === "inc") {
                result = `<span><i class="mdi mdi-arrow-up-circle text-danger font-weight-bold" style="font-size: 15px;"></i> ${row.changeValue} </span>`;
              }
              if (data === "dec") {
                result = `<span><i class="mdi mdi-arrow-down-circle text-success font-weight-bold"
                                style="font-size: 15px;"></i> ${row.changeValue} </span>`;
              }
              return result;
            },
          },
          {
            data: "debit",
            name: "Debit",
            render: function (data) {
              if (data == null) {
                return "";
              }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "battery",
            name: "Battery",
            render: function (data, type, row) {
              if (data == null) {
                return "";
              }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
        ];
        COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4, 5] }];
        HEADER_ROW = `<tr>
                      <th>Tanggal</th>
                      <th>Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                      <th>TMA <small class="text-muted">(cm)</small></th>
                      <th>Perubahan </th>
                      <th>Debit <small class="text-muted">(L/s)</small></th>
                      <th>Baterai <small class="text-muted">(v)</small></th>
                    </tr>`;
        if (!USE_BATTERY_COLUMN) {
          COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4] }];
          HEADER_ROW = `<tr>
                      <th>Tanggal</th>
                      <th>Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                      <th>TMA <small class="text-muted">(cm)</small></th>
                      <th>Perubahan </th>
                      <th>Debit <small class="text-muted">(L/s)</small></th>
                    </tr>`;
          COLUMNS = COLUMNS.filter(function (item) {
            return item.name !== "Battery";
          });
        }
        break;
    }

    var minuteMeta = prepareMinuteRowMeta(
      COLUMNS,
      COLUMNDEF,
      HEADER_ROW,
      timeCategory,
    );
    COLUMNS = minuteMeta.columns;
    COLUMNDEF = minuteMeta.columnDef;
    HEADER_ROW = minuteMeta.headerRow;
    if (
      minuteMeta.applied &&
      typeof agwlrElevColIndex === "number" &&
      agwlrElevColIndex >= 0
    ) {
      agwlrElevColIndex += 1;
    }

    $(`#${idTable} thead`).html(HEADER_ROW);
    $(`#${idTable}`).DataTable(withMinuteRowCount({
      dom: "rti",
      paging: false,
      ordering: false,
      processing: true,
      serverSide: true,
      ajax: {
        url: STATION_URL,
        type: "POST",
        data: {
          stationId: STATION_ID,
          deviceId: DEVICE_ID,
          filterDate: filterDate,
          selectedTime: timeCategory,
          stationType: STATION_TYPE,
        },
      },
      columnDefs: COLUMNDEF,
      columns: COLUMNS,
    }, timeCategory, filterDate, minuteMeta.applied));
  }

  if (typePos == EnumStationType.OpenStandpipe) {
    switch (timeCategory) {
      case "day":
        COLUMNS = [
          {
            data: "readingDate",
            name: "readingDate",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "-";
              return moment.parseZone(data).locale("id").format("D MMMM YYYY");
            },
          },
          {
            data: "waterLevelAvg",
            name: "WaterLevelAvg",
            render: function (data) {
              return `<strong>${formatNumber(data)} </strong>`;
            },
          },
          {
            data: "waterLevelMin",
            name: "WaterLevelMin",
            render: function (data) {
              return `<strong>${formatNumber(data)} </strong>`;
            },
          },
          {
            data: "waterLevelMax",
            name: "WaterLevelMax",
            render: function (data) {
              return `<strong>${formatNumber(data)} </strong>`;
            },
          },
        ];

        COLUMNDEF = [{ className: "dt-center", targets: [0, 1, 2, 3] }];

        HEADER_ROW = ` <tr>
                        <th>Tanggal</th>
                        <th>TMA Rerata <small class="text-muted">(cm)</small></th>
                        <th>TMA Minimum <small class="text-muted">(cm)</small></th>
                        <th>TMA Maksimum <small class="text-muted">(cm)</small></th>
                      </tr>`;
        break;
      case "hour":
        COLUMNS = [
          {
            data: "readingHour",
            name: "ReadingHour",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "-";
              return moment.parseZone(data).locale("id").format("D MMMM YYYY");
            },
          },
          {
            data: "readingHour",
            name: "ReadingHour",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "-";
              return moment.parseZone(data).locale("id").format("HH:mm");
            },
          },
          {
            data: "waterLevel",
            name: "WaterLevel",
            render: function (data) {
              // if (IS_ONLY_MDPL) {
              //   return null;
              // }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "changeStatus",
            name: "ChangeStatus",
            render: function (data, type, row) {
              let result = "";
              if (data === "inc") {
                result = `<span><i class="mdi mdi-arrow-up-circle text-danger font-weight-bold" style="font-size: 15px;"></i> ${row.changeValue} </span>`;
              }
              if (data === "dec") {
                result = `<span><i class="mdi mdi-arrow-down-circle text-success font-weight-bold"
                                style="font-size: 15px;"></i> ${row.changeValue} </span>`;
              }
              return result;
            },
          },

          {
            data: "battery",
            name: "Battery",
            render: function (data, type, row) {
              if (data == null) {
                return "";
              }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
        ];
        COLUMNDEF = [{ className: "dt-center", targets: [0, 1, 2, 3, 4] }];
        HEADER_ROW = `<tr>
                      <th>Tanggal</th>
                      <th>Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                      <th>TMA <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                      <th>Perubahan </th>
                      <th>Baterai <small class="text-muted">(v)</small></th>
                    </tr>`;
        if (!USE_BATTERY_COLUMN) {
          COLUMNDEF = [{ className: "dt-center", targets: [0, 1, 2, 3] }];
          HEADER_ROW = `<tr>
                      <th>Tanggal</th>
                      <th>Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                      <th>TMA <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                      <th>Perubahan </th>
                    </tr>`;
          COLUMNS = COLUMNS.filter(function (item) {
            return item.name !== "Battery";
          });
        }
        break;
      default:
        COLUMNS = [
          {
            data: "readingAt",
            name: "ReadingAt",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "-";
              return moment.parseZone(data).locale("id").format("D MMMM YYYY");
            },
          },
          {
            data: "readingAt",
            name: "ReadingAt",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "-";
              return moment.parseZone(data).locale("id").format("HH:mm");
            },
          },
          {
            data: "waterLevel",
            name: "WaterLevel",
            render: function (data) {
              // if (IS_ONLY_MDPL) {
              //   return null;
              // }
              return `<strong>${data} ${UNIT_DISPLAY}</strong>`;
            },
          },
          {
            data: "changeStatus",
            name: "ChangeStatus",
            render: function (data, type, row) {
              let result = "";
              if (data === "inc") {
                result = `<span><i class="mdi mdi-arrow-up-circle text-danger font-weight-bold" style="font-size: 15px;"></i> ${row.changeValue} </span>`;
              }
              if (data === "dec") {
                result = `<span><i class="mdi mdi-arrow-down-circle text-success font-weight-bold"
                                style="font-size: 15px;"></i> ${row.changeValue} </span>`;
              }
              return result;
            },
          },

          {
            data: "battery",
            name: "Battery",
            render: function (data, type, row) {
              if (data == null) {
                return "-";
              }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
        ];
        COLUMNDEF = [{ className: "dt-center", targets: [0, 1, 2, 3, 4] }];
        HEADER_ROW = `<tr>
                      <th>Tanggal</th>
                      <th>Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                      <th>TMA <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                      <th>Perubahan </th>
                      <th>Baterai <small class="text-muted">(v)</small></th>
                    </tr>`;
        if (!USE_BATTERY_COLUMN) {
          COLUMNDEF = [{ className: "dt-center", targets: [0, 1, 2, 3] }];
          HEADER_ROW = `<tr>
                      <th>Tanggal</th>
                      <th>Jam <small class="text-muted">(${TIME_ZONE})</small></th>
                      <th>TMA <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                      <th>Perubahan </th>
                    </tr>`;
          COLUMNS = COLUMNS.filter(function (item) {
            return item.name !== "Battery";
          });
        }
        break;
    }

    var minuteMeta = prepareMinuteRowMeta(
      COLUMNS,
      COLUMNDEF,
      HEADER_ROW,
      timeCategory,
    );
    COLUMNS = minuteMeta.columns;
    COLUMNDEF = minuteMeta.columnDef;
    HEADER_ROW = minuteMeta.headerRow;
    if (
      minuteMeta.applied &&
      typeof agwlrElevColIndex === "number" &&
      agwlrElevColIndex >= 0
    ) {
      agwlrElevColIndex += 1;
    }

    $(`#${idTable} thead`).html(HEADER_ROW);
    $(`#${idTable}`).DataTable(withMinuteRowCount({
      dom: "rti",
      paging: false,
      ordering: false,
      processing: true,
      serverSide: true,
      ajax: {
        url: STATION_URL,
        type: "POST",
        data: {
          stationId: STATION_ID,
          deviceId: DEVICE_ID,
          filterDate: filterDate,
          selectedTime: timeCategory,
          stationType: STATION_TYPE,
        },
      },
      columnDefs: COLUMNDEF,
      columns: COLUMNS,
    }, timeCategory, filterDate, minuteMeta.applied));
  }

  if (typePos == EnumStationType.AWLR_ARR) {
    switch (timeCategory) {
      case "day":
        $("#awlr-telemetry-info").fadeOut(100);
        $("#arr-telemetry-info").fadeIn(250);
        COLUMNS = [
          {
            data: "readingDate",
            name: "readingDate",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "";
              return moment.parseZone(data).locale("id").format("D MMMM YYYY");
            },
          },
          {
            data: "waterLevelAvg",
            name: "WaterLevelAvg",
            render: function (data) {
              //  if (IS_ONLY_MDPL) {
              //    return "-";
              //  }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "waterLevelMin",
            name: "WaterLevelMin",
            render: function (data) {
              //  if (IS_ONLY_MDPL) {
              //    return "-";
              //  }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "waterLevelMax",
            name: "WaterLevelMax",
            render: function (data) {
              //  if (IS_ONLY_MDPL) {
              //    return "-";
              //  }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "rainfall",
            name: "Rainfall",
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData > 5 && cellData < 20.1) {
                $(td).addClass("bg-hujan-ringan");
              } else if (cellData > 20 && cellData < 50.1) {
                $(td).addClass("bg-hujan-sedang");
              } else if (cellData > 50 && cellData < 100.1) {
                $(td).addClass("bg-hujan-lebat");
              } else if (cellData > 100) {
                $(td).addClass("bg-hujan-sangat-lebat");
              } else {
                $(td).addClass("bg-berawan");
              }
            },
            render: function (data) {
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "intensity",
            name: "Intensity",
            render: function (data) {
              return `
                      <div class="d-flex justify-content-center align-items-center">
                          ${getIntensityIcon(data)}
                      </div>
                  `;
            },
          },
        ];
        COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4, 5] }];
        HEADER_ROW = `<tr>
                        <th rowspan="2">Tanggal</th>
                        <th colspan="3">Tinggi Muka Air</th>
                        <th colspan="2">Curah Hujan</th>
                      </tr>
                      <tr>
                        <th>TMA Rerata <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                        <th>TMA Minimum <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                        <th>TMA Maksimum <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                        <th>CH <small class="text-muted">(mm)</small></th>
                        <th>Intensitas</th>
                      </tr>`;
        break;
      case "hour":
        $("#awlr-telemetry-info").fadeIn(250);
        $("#arr-telemetry-info").fadeIn(250);
        COLUMNS = [
          {
            data: "readingHour",
            name: "ReadingHour",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "";
              return moment.parseZone(data).locale("id").format("D MMMM YYYY");
            },
          },
          {
            data: "readingHour",
            name: "ReadingHour",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "";
              return moment.parseZone(data).locale("id").format("HH:mm");
            },
          },
          {
            data: "waterLevel",
            name: "WaterLevel",
            createdCell: function (td, cellData, rowData, row, col) {
              generateStyleWaterLevel(td, cellData, rowData, row, col);
            },
            render: function (data) {
              // if (IS_ONLY_MDPL) {
              //   return "-";
              // }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },

          {
            data: "debit",
            name: "Debit",
            render: function (data) {
              if (data == null) {
                return "-";
              }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },

          // {
          //   data: 'warningStatus',
          //   name: 'warningStatus',

          //   render: function (data) {
          //     // if (IS_ONLY_MDPL) {
          //     //   return null;
          //     // }
          //     let status = '';
          //     let style = '';
          //     switch (data) {
          //       case 0:
          //         status = 'Normal';
          //         style = 'text bg-normal';
          //         break;

          //       case 3:
          //         status = 'Waspada';
          //         style = 'text bg-siaga3';
          //         break;

          //       case 2:
          //         status = 'Siaga';
          //         style = 'text bg-siaga2';
          //         break;

          //       case 1:
          //         status = 'Awas';
          //         style = 'text bg-siaga1';
          //         break;
          //       default:
          //         status = 'Tanpa Status';
          //         break;
          //     }

          //     // return `<p class ="text bg-siaga3 text-bold">Siaga 3</p>`;
          //     if (data == null)
          //       return `<small class="text-muted fst-italic">Tanpa Status</small>`;
          //     return `<p class ="${style}">${data}</p>`;
          //   },
          // },

          {
            data: "rainfall",
            name: "Rainfall",
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData > 0 && cellData < 5.1) {
                $(td).addClass("bg-hujan-ringan");
              } else if (cellData > 5 && cellData < 10.1) {
                $(td).addClass("bg-hujan-sedang");
              } else if (cellData > 10 && cellData < 20.1) {
                $(td).addClass("bg-hujan-lebat");
              } else if (cellData > 20) {
                $(td).addClass("bg-hujan-sangat-lebat");
              } else {
                $(td).addClass("bg-berawan");
              }
            },
            render: function (data) {
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "intensity",
            name: "Intensity",
            render: function (data) {
              return `
                      <div class="d-flex justify-content-center align-items-center">
                          ${getIntensityIcon(data)}
                      </div>
                  `;
            },
          },

          {
            data: "batteryVoltage",
            name: "BatteryVoltage",
            render: function (data, type, row) {
              if (data == null) {
                return "-";
              }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "batteryCapacity",
            name: "BatteryCapacity",
            render: function (data, type, row) {
              if (data == null) {
                return "-";
              }
              return `<strong>${data}</strong>`;
            },
          },
        ];
        COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4, 5] }];
        HEADER_ROW = `
                    <tr>
                      <th rowspan="2">Tanggal</th>
                      <th rowspan="2">
                        Jam <small class="text-muted">(${TIME_ZONE})</small>
                      </th>

                      <th colspan="3">Tinggi Muka Air</th>
                      <th colspan="2">Curah Hujan</th>

                      <!-- BATERAI -->
                      <th colspan="2">Baterai</th>
                    </tr>
                    <tr>
                      <th>TMA <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                      <th>Debit <small class="text-muted">(m<sup>3</sup>/s)</small></th>

                      <th>CH <small class="text-muted">(mm)</small></th>
                      <th>Intensitas</th>

                      <!-- SUB BATERAI -->
                      <th>Tegangan <small class="text-muted">(V)</small></th>
                      <th>Kapasitas <small class="text-muted">(%)</small></th>
                    </tr>
                  `;

        if (!USE_BATTERY_COLUMN) {
          COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4, 5] }];

          HEADER_ROW = `
              <tr>
                <th rowspan="2">Tanggal</th>
                <th rowspan="2">
                  Jam <small class="text-muted">(${TIME_ZONE})</small>
                </th>

                <th colspan="3">Tinggi Muka Air</th>
                <th colspan="2">Curah Hujan</th>
              </tr>
              <tr>
                <th>TMA <small class="text-muted">(${UNIT_DISPLAY})</small></th>
                <th>Debit <small class="text-muted">(m<sup>3</sup>/s)</small></th>

                <th>CH <small class="text-muted">(mm)</small></th>
                <th>Intensitas</th>
              </tr>
            `;

          // Hilangkan 2 kolom baterai
          COLUMNS = COLUMNS.filter(
            (item) =>
              item.name !== "BatteryVoltage" && item.name !== "BatteryCapacity",
          );
        }

        break;
      default:
        $("#awlr-telemetry-info").fadeIn(250);
        $("#arr-telemetry-info").fadeOut(200);
        COLUMNS = [
          {
            data: "readingAt",
            name: "ReadingAt",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "";
              return moment.parseZone(data).locale("id").format("D MMMM YYYY");
            },
          },
          {
            data: "readingAt",
            name: "ReadingAt",
            render: function (data, type, row) {
              if (data == "" ?? data == null ?? data == undefined) return "-";
              return moment.parseZone(data).locale("id").format("HH:mm");
            },
          },
          {
            data: "waterLevel",
            name: "WaterLevel",
            createdCell: function (td, cellData, rowData, row, col) {
              generateStyleWaterLevel(td, cellData, rowData, row, col);
            },
            render: function (data) {
              // if (IS_ONLY_MDPL) {
              //   console.log(data)
              //   return "-";
              // }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },

          {
            data: "changeStatus",
            name: "ChangeStatus",
            render: function (data, type, row) {
              let result = "";
              if (data === "inc") {
                result = `<span><i class="mdi mdi-arrow-up-circle text-danger font-weight-bold" style="font-size: 15px;"></i> ${row.changeValue} </span>`;
              }
              if (data === "dec") {
                result = `<span><i class="mdi mdi-arrow-down-circle text-success font-weight-bold"
                                style="font-size: 15px;"></i> ${row.changeValue} </span>`;
              }
              return result;
            },
          },

          {
            data: "debit",
            name: "Debit",
            render: function (data) {
              if (data == null) {
                return "-";
              }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },

          {
            data: "rainfall",
            name: "Rainfall",
            render: function (data) {
              if (data == null) {
                return "-";
              }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "batteryVoltage",
            name: "BatteryVoltage",
            render: function (data, type, row) {
              if (data == null) {
                return "-";
              }
              return `<strong>${formatNumber(data)}</strong>`;
            },
          },
          {
            data: "batteryCapacity",
            name: "BatteryCapacity",
            render: function (data, type, row) {
              if (data == null) {
                return "-";
              }
              return `<strong>${data}</strong>`;
            },
          },
        ];
        COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4, 5] }];
        HEADER_ROW = `
                    <tr>
                      <th rowspan="2">Tanggal</th>
                      <th rowspan="2">
                        Jam <small class="text-muted">(${TIME_ZONE})</small>
                      </th>

                      <th colspan="3">Tinggi Muka Air</th>

                      <th rowspan="2">
                        Curah Hujan <br>
                        <small class="text-muted">(mm)</small>
                      </th>

                      <!-- BATERAI -->
                      <th colspan="2">Baterai</th>
                    </tr>
                    <tr>
                      <th>
                        TMA <small class="text-muted">(${UNIT_DISPLAY})</small>
                      </th>
                      <th>Perubahan</th>
                      <th>
                        Debit <small class="text-muted">(m<sup>3</sup>/s)</small>
                      </th>

                      <!-- SUB BATERAI -->
                      <th>Tegangan <small class="text-muted">(V)</small></th>
                      <th>Kapasitas <small class="text-muted">(%)</small></th>
                    </tr>
                  `;

        if (!USE_BATTERY_COLUMN) {
          COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3, 4, 5] }];

          HEADER_ROW = `
            <tr>
              <th rowspan="2">Tanggal</th>
              <th rowspan="2">
                Jam <small class="text-muted">(${TIME_ZONE})</small>
              </th>

              <th colspan="3">Tinggi Muka Air</th>

              <th rowspan="2">
                Curah Hujan <br>
                <small class="text-muted">(mm)</small>
              </th>
            </tr>
            <tr>
              <th>
                TMA <small class="text-muted">(${UNIT_DISPLAY})</small>
              </th>
              <th>Perubahan</th>
              <th>
                Debit <small class="text-muted">(m<sup>3</sup>/s)</small>
              </th>
            </tr>
          `;

          // Hilangkan 2 kolom baterai
          COLUMNS = COLUMNS.filter(
            (item) =>
              item.name !== "BatteryVoltage" && item.name !== "BatteryCapacity",
          );
        }

        break;
    }

    var minuteMeta = prepareMinuteRowMeta(
      COLUMNS,
      COLUMNDEF,
      HEADER_ROW,
      timeCategory,
    );
    COLUMNS = minuteMeta.columns;
    COLUMNDEF = minuteMeta.columnDef;
    HEADER_ROW = minuteMeta.headerRow;
    if (
      minuteMeta.applied &&
      typeof agwlrElevColIndex === "number" &&
      agwlrElevColIndex >= 0
    ) {
      agwlrElevColIndex += 1;
    }

    $(`#${idTable} thead`).html(HEADER_ROW);
    $(`#${idTable}`).DataTable(withMinuteRowCount({
      dom: "rti",
      paging: false,
      ordering: false,
      processing: true,
      serverSide: true,
      ajax: {
        url: STATION_URL,
        type: "POST",
        data: {
          stationId: STATION_ID,
          deviceId: DEVICE_ID,
          filterDate: filterDate,
          selectedTime: timeCategory,
          stationType: STATION_TYPE,
        },
      },
      columnDefs: COLUMNDEF,
      columns: COLUMNS,
    }, timeCategory, filterDate, minuteMeta.applied));
  }

  /* FLOW METER VERSI BARU => IKUT BAPENDA */
  if (typePos == EnumStationType.FlowMeter) {
    switch (timeCategory) {
      case "hour":
        COLUMNS = [
          {
            title: "Tanggal",
            data: "readingDate",
          },
          {
            title: "Jam (WIB)",
            data: "readingHourRange",
          },
          {
            title: OrganizationCode == "ORG061" ? "lt/detik" : "m³/s",
            data: "flowRate",
            defaultContent: "-",
            render: function (data, type, row, meta) {
              if (data == 0) return 0;
              const hasil = data / 3.6;
              if (data > 0) return formatNumber(hasil);
            },
          },
          {
            title: "m³/jam",
            data: "flowRate",
            defaultContent: "-",
            render: function (data, type, row, meta) {
              if (data == 0) return 0;
              if (data > 0) return formatNumber(data);
            },
          },
          {
            title: "lt/jam",
            data: "flowRate",
            defaultContent: "-",
            render: function (data, type, row, meta) {
              if (data == 0) return 0;
              const liter = data * 1000;
              if (data > 0) return formatNumber(liter);
            },
          },
          {
            // title: "Volume Total (m³)",
            data: null,
            render: function (data, type, row, meta) {
              let nextRow =
                meta.row + 1 < meta.settings.aoData.length
                  ? meta.settings.aoData[meta.row + 1]._aData
                  : null;

              return nextRow && typeof nextRow.flowTotal === "number"
                ? formatNumber(nextRow.flowTotal)
                : formatNumber(row.flowTotal)
                  ? formatNumber(row.flowTotal)
                  : "-";
            },
          },
          {
            title: "Tegangan (V)",
            data: "batteryVolt",
            render: function (data, type, row, meta) {
              return data ? formatNumber(data) : "-";
            },
          },
          {
            title: "Kapasitas (%)",
            data: "batteryCapacity",
            defaultContent: "-",
            render: function (data, type, row, meta) {
              return data ? parseFloat(data).toFixed(0) : "-";
            },
          },
        ];

        // COLUMNDEF = [{ className: "dt-center", targets: [1, 2, 3] }];

        HEADER_ROW = `<tr>
                          <th rowspan="2">Tanggal</th>
                          <th rowspan="2">Jam (WIB)</th>
                          <th colspan="3">${
                            OrganizationCode == "ORG061"
                              ? "Debit Pemakaian"
                              : "Volume Pemakaian"
                          } </th>
                         <th rowspan="2">
                            Volume Total (m³)
                            <svg data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Data Akumulatif"
                                style="cursor: pointer; margin-left: 5px; vertical-align: middle;"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="currentColor">
                              <circle cx="8" cy="8" r="7" stroke="currentColor" fill="none" stroke-width="1.5"/>
                              <path d="M8 7 L8 11 M8 5 L8 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                          </th>
                          <th colspan="2">Baterai Logger</th>
                      </tr>
                      <tr>
                          <th>lt/detik</th>
                          <th>m³/jam</th>
                          <th>lt/jam</th>
                          <th>Tegangan (V)</th>
                          <th>Kapasitas (%)</th>
                      </tr>`;

        if (POWER_SOURCE == "P") {
          COLUMNS = [
            {
              title: "Tanggal",
              data: "readingDate",
            },
            {
              title: "Jam (WIB)",
              data: "readingHourRange",
            },
            {
              title: "m³/s",
              data: "flowRate",
              defaultContent: "-",
              render: function (data, type, row, meta) {
                if (data == 0) return 0;
                const hasil = data / 3.6;
                if (data > 0) return formatNumber(hasil);
              },
            },
            {
              title: "m³/jam",
              data: "flowRate",
              defaultContent: "-",
              render: function (data, type, row, meta) {
                if (data == 0) return 0;
                if (data > 0) return formatNumber(data);
              },
            },
            {
              title: "lt/jam",
              data: "flowRate",
              defaultContent: "-",
              render: function (data, type, row, meta) {
                if (data == 0) return 0;
                const liter = data * 1000;
                if (data > 0) return formatNumber(liter);
              },
            },
            {
              title: "Volume Total (m³)",
              data: null,
              render: function (data, type, row, meta) {
                let nextRow =
                  meta.row + 1 < meta.settings.aoData.length
                    ? meta.settings.aoData[meta.row + 1]._aData
                    : null;

                return nextRow && typeof nextRow.flowTotal === "number"
                  ? formatNumber(nextRow.flowTotal)
                  : formatNumber(row.flowTotal)
                    ? formatNumber(row.flowTotal)
                    : "-";
              },
            },
          ];

          HEADER_ROW = `<tr>
                          <th rowspan="2">Tanggal</th>
                          <th rowspan="2">Jam (WIB)</th>
                          <th colspan="3">${
                            OrganizationCode == "ORG061"
                              ? "debit Bulanan"
                              : "Volume Bulanan"
                          }</th>
                          <th rowspan="2">Volume Total (m³)</th>
                      </tr>
                      <tr>
                          <th>liter/detik</th>
                          <th>m³/jam</th>
                          <th>lt/jam</th>
                      </tr>`;
        }

        break;
      case "day":
        COLUMNS = [
          {
            title: "Tanggal",
            data: "readingDate",
            render: (data) =>
              moment.parseZone(data).locale("id").format("D MMM YYYY"),
          },
          {
            title: "m³/hari",
            data: "flowRate",
            defaultContent: "-",
            render: function (data, type, row, meta) {
              if (data == 0) return 0;
              if (data > 0) return formatNumber(parseFloat(data));
            },
          },
          {
            title: "lt/hari",
            data: "flowRate",
            defaultContent: "-",
            render: function (data, type, row, meta) {
              if (data == 0) return 0;
              if (data > 0) return formatNumber(parseFloat(data) * 1000);
            },
          },
          {
            title: "Volume Total (m³)",
            data: "flowTotal",
            render: function (data) {
              return formatNumber(data);
            },
          },
        ];

        HEADER_ROW = `
        <tr>
            <th rowspan="2">Tanggal</th>
            <th colspan="2">Volume Harian</th>
            <th rowspan="2">Volume Total (m³)</th>
        </tr>
        <tr>
            <th>m³/hari</th>
            <th>lt/hari</th>
        </tr>`;

        break;
      default:
        break;
    }
    var minuteMeta = prepareMinuteRowMeta(
      COLUMNS,
      COLUMNDEF,
      HEADER_ROW,
      timeCategory,
    );
    COLUMNS = minuteMeta.columns;
    COLUMNDEF = minuteMeta.columnDef;
    HEADER_ROW = minuteMeta.headerRow;
    if (
      minuteMeta.applied &&
      typeof agwlrElevColIndex === "number" &&
      agwlrElevColIndex >= 0
    ) {
      agwlrElevColIndex += 1;
    }

    $(`#${idTable} thead`).html(HEADER_ROW);
    $(`#${idTable}`).DataTable(withMinuteRowCount({
      dom: "rti",
      paging: false,
      ordering: false,
      processing: true,
      serverSide: true,
      ajax: {
        url: STATION_URL,
        type: "POST",
        data: {
          stationId: STATION_ID,
          deviceId: DEVICE_ID,
          filterDate: filterDate,
          selectedTime: timeCategory,
          stationType: STATION_TYPE,
        },
      },
      // columnDefs: COLUMNDEF,
      columns: COLUMNS,
    }, timeCategory, filterDate, minuteMeta.applied));

    $('[data-bs-toggle="tooltip"]').tooltip();
  }

  /* ============================= */

  if (typePos == EnumStationType.VibratingWire && isAvwrTelemetryEnabled()) {
    const avwrTelemetry = getAvwrTelemetryModule();
    if (avwrTelemetry) {
      avwrTelemetry.renderDataTable({
        idTable: idTable,
        timeCategory: timeCategory,
        filterDate: filterDate,
        url: STATION_URL,
        stationId: STATION_ID,
        deviceId: DEVICE_ID,
        stationType: STATION_TYPE,
        useBatteryColumn: USE_BATTERY_COLUMN,
      });
    }
  }
}
/* -------- END Function untuk Generate DataTable ARR / AWLR / WQMS ----------*/
function getLastReadingDate(deviceId) {
  let result;
  $.ajax({
    url:
      "/Station/GetLastReadingDate?deviceId=" +
      deviceId +
      "&type=" +
      STATION_TYPE,
    type: "GET",
    async: false, // This makes the request synchronous
    success: function (data) {
      const currentDateTime = moment.parseZone(data.lastReading);
      const hour = currentDateTime.hour();
      result = currentDateTime.format("YYYY-MM-DD");
      // if (containsSubstring(STATION_TYPE, EnumStationType.ARR)) {
      //   if (hour < 7) {
      //      result = currentDateTime.subtract(1, 'days').format("YYYY-MM-DD");
      //   } else {
      //     result = currentDateTime.format("YYYY-MM-DD");
      //   }
      // } else {
      //   result = currentDateTime.format("YYYY-MM-DD");
      // }
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.error("Error:", textStatus, errorThrown);
      result = null;
    },
  });

  return result;
}

function formatNumber(num) {
  if (num == null ?? num == "") return "";
  // Ubah angka menjadi string dengan format lokal
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });
}

function getIntensityIcon(status, selectedTime = "hour") {
  let timeOfDay = "pagi";

  let momentjs = moment();
  momentjs.locale("id");

  momentjs.tz("Asia/Jakarta");

  let currentHour = momentjs.hours();

  if (currentHour >= 5 && currentHour < 10) {
    timeOfDay = "pagi";
  } else if (currentHour >= 10 && currentHour < 17) {
    timeOfDay = "siang";
  } else if (currentHour >= 17 && currentHour < 19) {
    timeOfDay = "sore";
  } else {
    timeOfDay = "malam";
  }

  let icon = "-";

  switch (status) {
    case 0:
      icon = '<small class="text-body fst-italic">Tidak Ada Hujan</small>';
      break;
    case 1:
      icon =
        '<img src="/images/arr/hujan-ringan.png" alt="Hujan Ringan" class="avatar-xs me-1"><small class="text-body fst-italic">Hujan Ringan</small>';
      break;
    case 2:
      icon =
        '<img src="/images/arr/hujan-sedang.png" alt="Hujan Sedang" class="avatar-xs me-1"><small class="text-body fst-italic">Hujan Sedang</small>';
      break;
    case 3:
      icon =
        '<img src="/images/arr/hujan-lebat.png" alt="Hujan Lebat" class="avatar-xs me-1"><small class="text-body fst-italic">Hujan Lebat</small>';
      break;
    case 4:
      icon =
        '<img src="/images/arr/hujan-sangat-lebat.png" alt="Hujan Sangat Lebat" class="avatar-xs me-1"><small class="text-body fst-italic">Hujan Sangat Lebat</small>';
      break;
  }

  return icon;
}
